import OrderFinancialBreakdown from 'src/components/shared/OrderFinancialBreakdown'
import ReceiptPriceGuidance from './components/ReceiptPriceGuidance'
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
  Button,
  Collapse,
  Modal,
  Select,
  Spin,
  Switch,
  Table,
  Alert,
  Tooltip,
  notification,
} from 'antd'
import { InfoCircleOutlined } from '@ant-design/icons'
import {
  addProduct,
  autoSendReconciledInvoiceToXero,
  createNewReceipting,
  fetchReceiptingOrders,
  fetchReceiptingProducts,
  getHistory,
  invalidateReceiptingOrdersCache,
  markOrderDelivered,
  setFilterDates,
  setReceiptingOrders,
  updateReceiptingOrder,
  updateReceiptingOrderHasVat,
  upsertPurchaseOrderSupplierDiscount,
} from '../../features/ReceiptingSlice'
import {
  buildOrderVatUpdatePayload,
  isOrderHasVatDraftDirty,
} from '../../utils/goodsReceiptingLineHelpers'
import {
  getReceiptingRowKey,
  isReceiptingRowKeyForPo,
} from '../../utils/receiptingRowKey'
import { Center } from '../../components/styled/FlexBox'
import {
  antdTableHorizontalScroll,
  visibleHorizontalScroll,
} from '../../components/styled/horizontalScroll'
import OrdersColumns from './OrdersColumns'
import ProductColumns from './ProductColumns'
import { persistVenueProductExcludeFromGrossProfitToggle } from 'src/screens/venue-products/venueProductInlineEdit'
import { isVenueProductExcludedFromGrossProfit } from 'src/utils/excludeFromGrossProfit'
import { RESPONSIVE_TABLE_SCROLL } from 'src/utils/responsiveTable'
import { promptExcludeFromGrossProfitDuplicateTitle } from 'src/utils/promptExcludeFromGrossProfitDuplicateTitle'
import {
  addVenueProduct,
  editVenueProduct,
  fetchVenueProducts,
} from 'src/features/VenueProductsSlice'
import {
  buildVenueProductCreatePayloadFromGrLine,
  findVenueProductForOrderLine,
} from 'src/utils/goodsReceiptingExcludeFromGrossProfit'
import ReceiptingFilter from './ReceiptingFilter'
import styled from 'styled-components/macro'
import { Prompt, useHistory, useLocation, Link } from 'react-router-dom'
import AddProductModal from './addProduct/AddProductModal'
import ThreeWayMatchEducation from 'src/components/shared/ThreeWayMatchEducation'
import { getTotalSpendReceiptingWithVAT } from '../../utils/priceFunctions'
import moment from 'moment'
import { findOrderAndUpdateState } from '../../features/OrdersSlice'
import AtttachInvoiceModal from './AtttachInvoiceModal'
import { editVenue } from 'src/features/VenueSlice'
import {
  XERO_AUTO_SEND_BODY,
  XERO_AUTO_SEND_SUPPLIER_HINT,
  XERO_AUTO_SEND_TOGGLE_LABEL,
  XERO_AUTO_SEND_REQUIRES_CONNECTION,
  XERO_AUTO_SEND_REQUIRES_RECONNECT,
  XERO_AUTO_SEND_PARTIAL_WAIT_COPY,
  XERO_AUTO_SEND_MANUAL_SEND_HINT,
  buildIntegrationsPath,
  buildVenueSuppliersPath,
  buildXeroAutoSendVenueUpdate,
  readXeroAutoSendEnabled,
  shouldShowXeroManualSendHint,
  toastPostReconcileXeroAutoSend,
} from 'src/utils/xeroAutoSendCopy'
import { shouldAutoSendAfterReconcile } from 'src/utils/xeroAutoSendBill'
import {
  RejectedNotification,
  SuccessNotification,
} from '../../notifications/SuccessNotification'
import { ReactMultiEmail, isEmail } from 'react-multi-email'
import PlanLimitModal from '../subscriptions/PlanLimitModal'
import { notifyGoodsReceiptingPaywallSales } from 'src/utils/goodsReceiptingPaywallNotify'
import { updateFeatureLimit } from 'src/features/SubscriptionSlice'
import ReconciliationHealthPanel from './components/ReconciliationHealthPanel'
import SupplierDiscountPanel, {
  canEditPoSupplierDiscount,
  isSupplierDiscountDraftDirty,
} from './components/SupplierDiscountPanel'
import {
  getReceiptingLineStatusForCredit,
  resolveAskForCredit,
} from 'src/utils/goodsReceiptingCreditHelpers'
import {
  FILTER_KEYS,
  filterOrdersByStatus,
  getHealthSummary,
  getInvoiceHealthSummary,
  buildInvoiceHealthItems,
  isReconciled,
  isInvoiceReconciledAgainstPurchaseOrder,
} from 'src/utils/reconciliationHealth'
import { buildRelatedOrderDatesByInvoiceId } from 'src/utils/reconciliationAlertCutoff'
import {
  resolveInitialStatusFilter,
  setStoredStatusFilter,
} from 'src/utils/reconciliationHealthStorage'
import {
  describePurchaseOrderOutsideReceiptingDates,
  receiptingRangeIncludingOrder,
  getReconciliationEmptyMessage,
} from 'src/utils/reconciliationHealthEmptyStates'
import { searchPurchaseOrders } from 'src/features/NewInvoicesSlice'
import { useGrowthEngineFeaturePage } from 'src/hooks/useGrowthEngineFeatureGuidance'
import useGrowthEngineSuggestedData from 'src/hooks/useGrowthEngineSuggestedData'
import GrowthEngineFeatureEmptyState from 'src/components/growthEngine/GrowthEngineFeatureEmptyState'
import GoodsReceiptingLimitUpsell from 'src/components/growthEngine/GoodsReceiptingLimitUpsell'
import {
  findSuggestedReceiptingOrder,
  getGoodsReceiptingEmptyCta,
  resolveGoodsReceiptingNeedOrderPath,
  shouldShowGoodsReceiptingGuidedEmpty,
} from 'src/utils/growthEngineRecommendation'
import {
  GOODS_RECEIPTING_RANGE_EMPTY_COPY,
  canWidenGoodsReceiptingRange,
  getWidenedGoodsReceiptingFilterDates,
  hasGoodsReceiptingPurchaseOrderHistory,
  shouldShowGoodsReceiptingRangeEmpty,
} from 'src/utils/growthEngineGoodsReceiptingRangeEmpty'
import {
  getGoodsReceiptingLimitReachedCopy,
  shouldShowGoodsReceiptingLimitReached,
} from 'src/utils/growthEngineGoodsReceiptingLimit'
import {
  bindGuidedEmptySuggestedActions,
  pickAcceptedSuggestedItem,
} from 'src/utils/growthEngineSuggestedData'
import { countReadyToReconcileInvoices } from 'src/utils/whyThisMatchHelpers'
import { mapInvoiceToTableRow } from 'src/utils/invoiceUploadHelpers'
import {
  getUploadedInvoices,
  rematchInvoiceMatching,
  rematchInvoicesForPurchaseOrders,
  removeInvoiceFromPurchaseOrder,
  linkInvoiceToPurchaseOrder,
  reconcileInvoiceOneClick,
} from 'src/features/NewInvoicesSlice'
import MatchInvoiceModal from 'src/screens/invoices/MatchInvoiceModal'
import GrMatchInvoiceChooserModal from './components/GrMatchInvoiceChooserModal'
import GrUploadInvoiceModal from './components/GrUploadInvoiceModal'
import GrAddInvoiceChooserModal from './components/GrAddInvoiceChooserModal'
import GrLinkExistingInvoiceModal from './components/GrLinkExistingInvoiceModal'
import {
  mergeRematchApiResultIntoInvoiceRow,
  shouldAutoRematchBeforeMatchOpen,
} from 'src/utils/invoiceMatchRefreshHelpers'
import {
  isAlreadyReconciledError,
  isForceReconcileRequiredError,
} from 'src/utils/whyThisMatchHelpers'
import {
  buildSaveReceiptingData,
  clearAsOrderedIdsForPo,
  resolveSaveReceiptingStatus,
} from 'src/utils/goodsReceiptingAsOrderedHelpers'
import { applyActualDeliveryDateToLines } from 'src/utils/actualDeliveryDate'
import {
  GR_ACCEPT_BLOCKED_SHORT_COPY,
  lineBlocksGrFullAccept,
} from 'src/utils/goodsReceiptingActionHelpers'
import {
  BULK_MARK_RECEIVED_LABEL,
  BULK_RESULT,
  buildBulkFullAcceptPayload,
  evaluateBulkMarkReceivedProducts,
  filterEligibleBulkMarkReceivedOrders,
  getBulkMarkReceivedDisabledReason,
  getBulkOrderSelectionKey,
  isEligibleForBulkMarkReceived,
  resolveBulkActualDeliveryDate,
} from 'src/utils/goodsReceiptingBulkHelpers'
import BulkMarkReceivedModal from './components/BulkMarkReceivedModal'
import {
  buildAppCheckInSuggestions,
  GR_APP_CHECK_IN_COPY,
  mergeAppCheckInSuggestions,
  shouldShowAppCheckInConfirmBanner,
} from 'src/utils/goodsReceiptingAppCheckInBridgeHelpers'
import { excludeVoidedGoodsReceiptingOrders } from 'src/utils/goodsReceiptingVoidHelpers'
import {
  buildGrLinkExistingBody,
  GR_LINK_EXISTING_COPY,
} from 'src/utils/goodsReceiptingLinkExistingHelpers'
import {
  CN_DOCUMENT_COPY,
  getCreditNoteApplySuccessCopy,
  getCreditNoteAbsolutePennies,
  isCreditNoteDocument,
} from 'src/utils/creditNoteDocumentHelpers'
import { maybePromptAndCloseCreditRequestAfterCnApply } from 'src/utils/maybePromptAndCloseCreditRequestAfterCnApply'
import {
  getChooserInvoicesForReceiptingOrder,
  getGoodsReceiptingMatchActionState,
  getMatchableInvoicesForReceiptingOrder,
  getPostReceiptMatchOffer,
  shouldOpenMatchChooserForReceiptingOrder,
} from 'src/utils/goodsReceiptingMatchHelpers'
import {
  parseReceiptingFilterFromSearch,
  parseReceiptingSearchQueryFromSearch,
  parseReceiptingDateRangeFromSearch,
  fetchOpenCreditRequestCount,
} from 'src/utils/reconciliationHealthApi'
import {
  notifyVenueHomeChanged,
  venueHomeReturnPath,
} from 'src/utils/venueHomeApi'
import { API } from 'src/utils/interceptor'
import { useCanAccess } from 'src/hooks/useIsBlocked'
import {
  FOOD_SAFETY_DELIVERY_CHECK_LABEL,
  buildFoodSafetyDeliveryCheckPath,
  foodSafetyDeliveryCheckTarget,
} from 'src/utils/foodSafetyDeliveryCheckLink'
import {
  buildReconciliationEmailSettingsPayload,
  normalizeReconciliationEmailSettings,
} from 'src/utils/reconciliationEmailSettings'
const { Panel } = Collapse
const { Option } = Select
const SETTINGS_PANEL_KEY = 'settings'

const Receipting = ({
  embedded = false,
  embeddedPo = '',
  onReceiptSaved,
} = {}) => {
  const dispatch = useDispatch()
  const history = useHistory()
  const location = useLocation()
  const venueId = useSelector(state => state.venue.venue?._id)
  const venue = useSelector(state => state.venue.venue)
  const canSeeFoodSafety = useCanAccess('food-safety')
  const {
    guidedSuccess,
    recommendation: growthEngineRecommendation,
    ladder: growthEngineLadder,
  } = useGrowthEngineFeaturePage({
    venueId,
    surface: 'receipting',
    featureId: 'goods_receipting',
  })
  const suggested = useGrowthEngineSuggestedData({
    venueId,
    featureId: 'goods_receipting',
    items: guidedSuccess?.suggestedData?.items,
  })
  const [invoiceModalData, setInvoiceModalData] = useState(null)
  const [matchModalInvoice, setMatchModalInvoice] = useState(null)
  const [matchChooser, setMatchChooser] = useState({
    visible: false,
    order: null,
    invoices: [],
    focusInvoiceId: null,
  })
  const [removingChooserInvoiceId, setRemovingChooserInvoiceId] = useState(null)
  const [grUpload, setGrUpload] = useState({
    visible: false,
    order: null,
  })
  const [grAddInvoiceChooser, setGrAddInvoiceChooser] = useState({
    visible: false,
    order: null,
  })
  const [grLinkExisting, setGrLinkExisting] = useState({
    visible: false,
    order: null,
    selectedInvoiceId: null,
  })
  const [grLinkExistingSaving, setGrLinkExistingSaving] = useState(false)
  const [rematchingInvoiceId, setRematchingInvoiceId] = useState(null)
  const automaticSendToXero = readXeroAutoSendEnabled(venue)
  const [editLoading, setEditLoading] = useState(false)
  const [orderHasVatDraft, setOrderHasVatDraft] = useState({})
  const [savingOrderHasVatKey, setSavingOrderHasVatKey] = useState(null)
  const [savingSupplierDiscountKey, setSavingSupplierDiscountKey] =
    useState(null)
  const [bulkSelectedRowKeys, setBulkSelectedRowKeys] = useState([])
  const [bulkModalVisible, setBulkModalVisible] = useState(false)
  const [bulkProcessing, setBulkProcessing] = useState(false)
  const [bulkProgress, setBulkProgress] = useState({ done: 0, total: 0 })
  const [bulkResults, setBulkResults] = useState(null)

  const receiptingOrders = useSelector(
    state => state.receipting.receiptingOrders,
  )
  const voidedReceiptingOrders = useSelector(
    state => state.receipting.voidedReceiptingOrders || [],
  )

  const receiptingProducts = useSelector(
    state => state.receipting.receiptingProducts,
  )
  const receiptingLoading = useSelector(
    state => state.receipting.receiptingLoading,
  )
  const venueProducts = useSelector(state => state.venueProducts.products)

  const isLoading = useSelector(state => state.receipting.isLoading)
  const filterDateBasis = useSelector(state => state.receipting.filterDateBasis)
  const [outsideDateMessage, setOutsideDateMessage] = useState('')
  const [outsideOrderDate, setOutsideOrderDate] = useState('')
  const receiptingHistory = useSelector(state => state.receipting.history)
  const historyLoading = useSelector(state => state.receipting.historyLoading)
  const user = useSelector(state => state.auth.account.name)
  /** Full account — retrospective edits send username for server-side role checks. */
  const authAccount = useSelector(state => state.auth.account)
  const createdReceipting = useSelector(
    state => state.receipting.createdReceipting,
  )
  const filterDates = useSelector(state => state.receipting.filterDates)

  const [editedReceipting, setEditedReceipting] = useState([])
  const [asOrderedLineIds, setAsOrderedLineIds] = useState([])
  const [weightedItems, setWeightedItems] = useState([])
  /** Draft PO supplier discounts keyed by getReceiptingRowKey */
  const [supplierDiscountDrafts, setSupplierDiscountDrafts] = useState({})
  const [addingShoppingListLineId, setAddingShoppingListLineId] = useState(null)
  const [ordersToAdding, setOrdersToAdding] = useState({})
  const [modalShow, setModalShow] = useState(false)
  const [historyModalShow, setHistoryModalShow] = useState(false)
  const [isSupplierChecked, setIsSupplierChecked] = useState(false)
  const [isPoChecked, setIsPoChecked] = useState(true)
  const [searchQuery, setSearchQuery] = useState('')
  const [isEmptySearch, setIsEmptySearch] = useState(false)
  const [statusFilter, setStatusFilter] = useState(FILTER_KEYS.ALL)
  const [showPlanLimitModal, setShowPlanLimitModal] = useState(false)
  const [planLimitVariant, setPlanLimitVariant] = useState(
    'reconciliationEmailReports',
  )
  const [settingsPanelOpen, setSettingsPanelOpen] = useState(false)
  const [showEmailSettingsSaved, setShowEmailSettingsSaved] = useState(false)
  const [reconciliationReportEmails, setReconciliationReportEmails] = useState(
    [],
  )
  const [reconciliationReportFrequency, setReconciliationReportFrequency] =
    useState('none')
  const receiptingExist = useSelector(
    state => state.receipting.receiptingOrdersAlreadyExists,
  )
  const uploadedInvoices = useSelector(
    state => state.newInvoices.uploadedInvoices,
  )
  const usageLimits =
    useSelector(state => state.venue?.venue?.usageLimits) ?? {}
  const currentPlan = usageLimits?.currentPlan
  const isFreePlan = currentPlan === 'Free'
  const goodsReceiptingRemaining =
    usageLimits?.features?.Goods_Receipting?.limit

  const openGoodsReceiptingPaywall = useCallback(
    ({ purchaseOrderNumber = null, supplierTitle = null } = {}) => {
      notifyGoodsReceiptingPaywallSales({
        venueId,
        source: 'client',
        platform: 'dashboard',
        remainingLimit:
          goodsReceiptingRemaining == null
            ? 0
            : Number(goodsReceiptingRemaining),
        purchaseOrderNumber,
        supplierTitle,
      })
      setPlanLimitVariant('goodsReceiptingLimit')
      setShowPlanLimitModal(true)
    },
    [venueId, goodsReceiptingRemaining],
  )

  /** Free/Starter/Growth have a monthly PO receipting cap; Pro has no key. */
  const isGoodsReceiptingBlocked =
    currentPlan !== 'Pro' &&
    goodsReceiptingRemaining != null &&
    Number(goodsReceiptingRemaining) <= 0

  const showGoodsReceiptingLimitReached = shouldShowGoodsReceiptingLimitReached(
    {
      remaining: goodsReceiptingRemaining,
      plan: currentPlan,
      loading: isLoading && receiptingOrders.length === 0,
    },
  )
  const goodsReceiptingLimitCopy = showGoodsReceiptingLimitReached
    ? getGoodsReceiptingLimitReachedCopy({
        recommendation: growthEngineRecommendation,
        guidedSuccess,
        plan: currentPlan,
      })
    : null

  const consumeGoodsReceiptingAllowance = useCallback(async () => {
    if (!venueId) return
    if (goodsReceiptingRemaining == null) return
    if (Number(goodsReceiptingRemaining) <= 0) return
    try {
      await dispatch(updateFeatureLimit(venueId, 'Goods_Receipting'))
    } catch (err) {
      console.warn('Goods_Receipting limit update failed', err)
    }
  }, [dispatch, venueId, goodsReceiptingRemaining])

  const healthSummary = useMemo(() => {
    const summary = getHealthSummary(
      excludeVoidedGoodsReceiptingOrders(receiptingOrders),
      uploadedInvoices,
    )
    return {
      ...summary,
      voided: Array.isArray(voidedReceiptingOrders)
        ? voidedReceiptingOrders.length
        : 0,
    }
  }, [receiptingOrders, voidedReceiptingOrders, uploadedInvoices])

  const [openCreditRequestCount, setOpenCreditRequestCount] = useState(0)

  useEffect(() => {
    if (venueId) dispatch(fetchVenueProducts(venueId))
  }, [dispatch, venueId])

  useEffect(() => {
    if (!venueId) {
      setOpenCreditRequestCount(0)
      return undefined
    }
    let cancelled = false
    fetchOpenCreditRequestCount({ venueId, apiGet: API.get })
      .then(count => {
        if (!cancelled) setOpenCreditRequestCount(count)
        return null
      })
      .catch(() => {
        if (!cancelled) setOpenCreditRequestCount(0)
        return null
      })
    return () => {
      cancelled = true
    }
  }, [venueId])

  const invoiceRows = useMemo(
    () => uploadedInvoices.map(invoice => mapInvoiceToTableRow(invoice)),
    [uploadedInvoices],
  )

  const relatedOrderDatesByInvoiceId = useMemo(
    () =>
      buildRelatedOrderDatesByInvoiceId(
        invoiceRows,
        excludeVoidedGoodsReceiptingOrders(receiptingOrders),
      ),
    [invoiceRows, receiptingOrders],
  )

  const invoiceHealth = useMemo(
    () =>
      getInvoiceHealthSummary(invoiceRows, {
        relatedOrderDatesByInvoiceId,
      }),
    [invoiceRows, relatedOrderDatesByInvoiceId],
  )

  const orphanInvoiceCount = useMemo(
    () => invoiceHealth.orphanInvoices || 0,
    [invoiceHealth],
  )

  const invoiceHealthItems = useMemo(
    () =>
      buildInvoiceHealthItems(invoiceRows, {
        limit: 8,
        relatedOrderDatesByInvoiceId,
      }),
    [invoiceRows, relatedOrderDatesByInvoiceId],
  )

  const readyToReconcileCount = useMemo(
    () => countReadyToReconcileInvoices(invoiceRows),
    [invoiceRows],
  )

  const ordersLoaded = receiptingExist === venueId

  const urlStatusFilter = useMemo(
    () => parseReceiptingFilterFromSearch(location.search),
    [location.search],
  )

  const urlSearchQuery = useMemo(() => {
    if (String(embeddedPo || '').trim()) return String(embeddedPo).trim()
    return parseReceiptingSearchQueryFromSearch(location.search)
  }, [embeddedPo, location.search])

  const urlDateRange = useMemo(
    () => parseReceiptingDateRangeFromSearch(location.search),
    [location.search],
  )

  useEffect(() => {
    if (!venueId) return
    dispatch(getUploadedInvoices(venueId))
  }, [dispatch, venueId])

  useEffect(() => {
    if (!venue?._id) return
    const normalized = normalizeReconciliationEmailSettings(venue)
    setReconciliationReportEmails(normalized.emails)
    setReconciliationReportFrequency(normalized.frequency)
  }, [venue?._id])

  // Ollie / health deep-links widen the date window so the referenced PO loads.
  useEffect(() => {
    if (!urlDateRange?.start || !urlDateRange?.end) return
    const startMs = moment(urlDateRange.start, 'YYYY-MM-DD').valueOf()
    const endMs = moment(urlDateRange.end, 'YYYY-MM-DD').endOf('day').valueOf()
    if (!Number.isFinite(startMs) || !Number.isFinite(endMs)) return
    dispatch(setFilterDates({ start: startMs, end: endMs }))
  }, [dispatch, urlDateRange?.start, urlDateRange?.end])

  useEffect(() => {
    // When a PO query is present, keep All so a stale status chip cannot hide it.
    if (!venueId || !ordersLoaded || !urlStatusFilter || urlSearchQuery) return

    setStatusFilter(urlStatusFilter)
    setStoredStatusFilter(venueId, urlStatusFilter)
  }, [venueId, ordersLoaded, urlStatusFilter, urlSearchQuery])

  useEffect(() => {
    if (!urlSearchQuery) return
    setSearchQuery(urlSearchQuery)
    setIsPoChecked(true)
    setIsSupplierChecked(false)
    setStatusFilter(FILTER_KEYS.ALL)
  }, [urlSearchQuery])

  useEffect(() => {
    if (!embedded || !venueId || !String(embeddedPo || '').trim()) return
    const widened = getWidenedGoodsReceiptingFilterDates()
    dispatch(
      fetchReceiptingOrders(
        venueId,
        moment(widened.start).format('DD/MM/YYYY'),
        moment(widened.end).format('DD/MM/YYYY'),
      ),
    )
  }, [dispatch, embedded, embeddedPo, venueId])

  useEffect(() => {
    if (!venueId || !ordersLoaded || urlStatusFilter || urlSearchQuery) return

    setStatusFilter(resolveInitialStatusFilter(venueId))
  }, [venueId, ordersLoaded, urlStatusFilter, urlSearchQuery])

  const handleStatusFilterChange = useCallback(
    filterKey => {
      setStatusFilter(filterKey)
      if (venueId) {
        setStoredStatusFilter(venueId, filterKey)
      }
    },
    [venueId],
  )

  const showOutsideOrder = useCallback(() => {
    const next = receiptingRangeIncludingOrder({
      orderDate: outsideOrderDate,
      start: filterDates?.start,
      end: filterDates?.end,
    })
    if (!next) return
    handleStatusFilterChange(FILTER_KEYS.ALL)
    dispatch(setFilterDates(next))
  }, [
    dispatch,
    filterDates?.end,
    filterDates?.start,
    handleStatusFilterChange,
    outsideOrderDate,
  ])

  const widenGoodsReceiptingDates = useCallback(() => {
    handleStatusFilterChange(FILTER_KEYS.ALL)
    dispatch(setFilterDates(getWidenedGoodsReceiptingFilterDates()))
  }, [dispatch, handleStatusFilterChange])

  const filteredOrders = useMemo(() => {
    const sourceOrders =
      statusFilter === FILTER_KEYS.VOIDED
        ? voidedReceiptingOrders
        : excludeVoidedGoodsReceiptingOrders(receiptingOrders)
    const statusFiltered = filterOrdersByStatus(
      sourceOrders,
      statusFilter === FILTER_KEYS.VOIDED ? FILTER_KEYS.ALL : statusFilter,
      uploadedInvoices,
    )
    const query = searchQuery.trim().toLowerCase()

    if (!query) {
      return statusFiltered
    }

    return statusFiltered.filter(item => {
      if (isPoChecked) {
        return item.purchaseOrderNumber?.toLowerCase()?.includes(query)
      }
      if (isSupplierChecked) {
        return item.supplier.title?.trim()?.toLowerCase()?.includes(query)
      }
      return true
    })
  }, [
    receiptingOrders,
    voidedReceiptingOrders,
    statusFilter,
    uploadedInvoices,
    searchQuery,
    isPoChecked,
    isSupplierChecked,
  ])

  const eligibleBulkOrders = useMemo(
    () => filterEligibleBulkMarkReceivedOrders(filteredOrders),
    [filteredOrders],
  )

  const eligibleBulkKeySet = useMemo(
    () => new Set(eligibleBulkOrders.map(getBulkOrderSelectionKey)),
    [eligibleBulkOrders],
  )

  const selectedBulkOrders = useMemo(
    () =>
      filteredOrders.filter(order =>
        bulkSelectedRowKeys.includes(getBulkOrderSelectionKey(order)),
      ),
    [filteredOrders, bulkSelectedRowKeys],
  )

  // Drop selections that fall out of the current filter / eligibility set.
  useEffect(() => {
    setBulkSelectedRowKeys(prev => {
      const next = prev.filter(key => eligibleBulkKeySet.has(key))
      if (
        next.length === prev.length &&
        next.every((key, index) => key === prev[index])
      ) {
        return prev
      }
      return next
    })
  }, [eligibleBulkKeySet])

  const tableEmptyText = useMemo(
    () => getReconciliationEmptyMessage(statusFilter, { searchQuery }),
    [statusFilter, searchQuery],
  )
  const hasPurchaseOrders =
    hasGoodsReceiptingPurchaseOrderHistory(growthEngineLadder)
  const canWidenReceiptingRange = canWidenGoodsReceiptingRange(filterDates)
  const receiptingOrdersForEmpty =
    excludeVoidedGoodsReceiptingOrders(receiptingOrders)
  const receiptingEmptyLoading = isLoading && receiptingOrders.length === 0
  const showGoodsReceiptingRangeEmpty = shouldShowGoodsReceiptingRangeEmpty({
    orders: receiptingOrdersForEmpty,
    hasPurchaseOrders,
    canWiden: canWidenReceiptingRange,
    loading: receiptingEmptyLoading,
  })
  const showGoodsReceiptingGuidedEmpty = shouldShowGoodsReceiptingGuidedEmpty({
    orders: receiptingOrdersForEmpty,
    guidedSuccess,
    loading: receiptingEmptyLoading,
    atLimit: showGoodsReceiptingLimitReached,
    hasPurchaseOrders,
    canWidenRange: canWidenReceiptingRange,
  })
  const showGoodsReceiptingLimitEmpty =
    showGoodsReceiptingLimitReached &&
    !showGoodsReceiptingGuidedEmpty &&
    !showGoodsReceiptingRangeEmpty &&
    excludeVoidedGoodsReceiptingOrders(receiptingOrders).length === 0
  const showGoodsReceiptingLimitBanner =
    showGoodsReceiptingLimitReached &&
    excludeVoidedGoodsReceiptingOrders(receiptingOrders).length > 0

  const [expandedRowKeys, setExpandedRowKeys] = useState([])
  /**
   * Retrospective receipt editing: PO key currently reopened for editing.
   * Null = normal (locked) behaviour. Keyed by getReceiptingRowKey.
   */
  const [retroEditKey, setRetroEditKey] = useState(null)
  /** PO keys already seeded with app check-in suggestions (Chunk C1). */
  const seededAppCheckInPoKeysRef = useRef(new Set())
  const asOrderedLineIdsRef = useRef(asOrderedLineIds)
  const editedReceiptingRef = useRef(editedReceipting)
  asOrderedLineIdsRef.current = asOrderedLineIds
  editedReceiptingRef.current = editedReceipting

  const isRetroEditActiveFor = record =>
    Boolean(retroEditKey) &&
    getReceiptingRowKey(record) === String(retroEditKey)

  /** Reopen a completed receipt for correction (Admin / Head Chef GM flow). */
  const startRetroEdit = record => {
    if (!record) return
    setRetroEditKey(getReceiptingRowKey(record))
    expandOrderRow(record)
  }

  const exitRetroEdit = record => {
    if (record && !isRetroEditActiveFor(record)) return
    setRetroEditKey(null)
  }

  const getSupplierDiscountDraft = record => {
    const key = getReceiptingRowKey(record)
    const draft = supplierDiscountDrafts[key]
    if (draft) return draft
    return {
      discountPennies: Math.max(
        0,
        Math.round(Number(record?.supplierDiscountPennies) || 0),
      ),
      note: String(record?.supplierDiscountNote || ''),
      linesReceivedPennies: Math.max(
        0,
        Math.round(
          Number(
            record?.totalSpendReceivedBeforeDiscount ??
              (Number(record?.totalSpendReceived) || 0) +
                (Number(record?.supplierDiscountPennies) || 0),
          ) || 0,
        ),
      ),
    }
  }

  const setSupplierDiscountDraftForRecord = (record, next) => {
    const key = getReceiptingRowKey(record)
    setSupplierDiscountDrafts(prev => ({
      ...prev,
      [key]: {
        discountPennies: Math.max(
          0,
          Math.round(Number(next.discountPennies) || 0),
        ),
        note: String(next.note || ''),
        linesReceivedPennies:
          next.linesReceivedPennies != null
            ? next.linesReceivedPennies
            : prev[key]?.linesReceivedPennies,
      },
    }))
  }

  useEffect(() => {
    const updatedOrders = receiptingOrders.map(order => {
      const currentOrder = receiptingProducts.find(
        item =>
          item.supplier === order.supplier._id &&
          item.purchaseOrderNumber === order.purchaseOrderNumber,
      )
      if (!currentOrder) return order
      const { totalSpend, totalVAT } = getTotalSpendReceiptingWithVAT(
        currentOrder.orders,
      )
      // Display-only ex/inc pair for the Receipted amount column, mirroring
      // the server's discount rule. totalSpend/totalSpendReceived keep their
      // existing meaning so the save flow is untouched. Ordered Inc comes from
      // the list API (`totalSpendOrderedIncVat`).
      const discountPennies = Math.max(
        0,
        Math.round(Number(order.supplierDiscountPennies) || 0),
      )
      return {
        ...order,
        totalSpend,
        totalSpendReceived: totalSpend,
        totalSpendReceivedVatExPennies: Math.max(
          0,
          totalSpend - totalVAT - discountPennies,
        ),
        totalSpendReceivedVatIncPennies: Math.max(
          0,
          totalSpend - discountPennies,
        ),
      }
    })
    dispatch(setReceiptingOrders(updatedOrders))
  }, [receiptingProducts])

  // Chunk C1: when products land for an expanded PO, suggest As ordered /
  // Report Error from app check-in (isDeleivered / receipting Not Saved).
  // Suggestions only — merge into local draft; never auto-Save.
  useEffect(() => {
    if (!expandedRowKeys.length || !receiptingProducts?.length) return

    const merges = []
    for (const key of expandedRowKeys) {
      if (seededAppCheckInPoKeysRef.current.has(key)) continue

      const parentOrder = receiptingOrders.find(
        order => getReceiptingRowKey(order) === key,
      )
      if (!parentOrder) continue

      const supplierId = parentOrder.supplier?._id || parentOrder.supplier
      const productBundle = receiptingProducts.find(item => {
        const itemSupplierId = item?.supplier?._id || item?.supplier
        return (
          String(itemSupplierId) === String(supplierId) &&
          item.purchaseOrderNumber === parentOrder.purchaseOrderNumber
        )
      })
      if (!productBundle?.orders?.length) continue

      seededAppCheckInPoKeysRef.current.add(key)
      const suggestions = buildAppCheckInSuggestions(
        productBundle.orders,
        parentOrder,
      )
      if (
        suggestions.asOrderedLineIds.length ||
        suggestions.reportErrorRows.length
      ) {
        merges.push(suggestions)
      }
    }

    if (!merges.length) return

    let nextAsOrdered = asOrderedLineIdsRef.current
    let nextEdited = editedReceiptingRef.current
    for (const suggestions of merges) {
      const merged = mergeAppCheckInSuggestions({
        asOrderedLineIds: nextAsOrdered,
        editedReceipting: nextEdited,
        suggestions,
      })
      nextAsOrdered = merged.asOrderedLineIds
      nextEdited = merged.editedReceipting
    }
    asOrderedLineIdsRef.current = nextAsOrdered
    editedReceiptingRef.current = nextEdited
    setAsOrderedLineIds(nextAsOrdered)
    setEditedReceipting(nextEdited)
  }, [expandedRowKeys, receiptingProducts, receiptingOrders])

  const isEditable = (order, field) => {
    const currentOrder = editedReceipting.find(item => item.order === order._id)
    switch (field) {
      case 'weight': {
        return true
      }
      case 'price': {
        return !!currentOrder
      }
      default: {
        return !!currentOrder
      }
    }
  }

  const openMatchInvoiceFromGr = async invoice => {
    if (!invoice?.id) return
    if (rematchingInvoiceId) return

    if (invoice.matchingStatus === 'possible_duplicate') {
      RejectedNotification({
        message: 'Possible duplicate',
        description:
          'Review this invoice on the Invoices tab first (archive or mark as not a duplicate), then Match from here.',
      })
      return
    }

    // Terminal lifecycle never opens Match & reconcile.
    if (invoice.status === 'reconciled' || invoice.status === 'sentToXero') {
      SuccessNotification({
        message: 'Already reconciled',
        description:
          'This invoice is already reconciled (or sent to Xero). Refreshing your list.',
      })
      await dispatch(getUploadedInvoices(venueId))
      return
    }

    if (shouldAutoRematchBeforeMatchOpen(invoice)) {
      setRematchingInvoiceId(invoice.id)
      try {
        const result = await rematchInvoiceMatching(invoice.id)
        const merged = mergeRematchApiResultIntoInvoiceRow(invoice, result)
        if (
          merged?.status === 'reconciled' ||
          merged?.status === 'sentToXero'
        ) {
          SuccessNotification({
            message: 'Already reconciled',
            description:
              'This invoice is already reconciled (or sent to Xero). Refreshing your list.',
          })
          void dispatch(getUploadedInvoices(venueId, { silent: true }))
          return
        }
        setMatchModalInvoice(merged)
        // Quiet refresh — avoid blanking GR while Match opens.
        void dispatch(getUploadedInvoices(venueId, { silent: true }))
      } catch (error) {
        RejectedNotification({
          message: 'Could not refresh matching',
          description:
            error?.response?.data?.message ||
            error?.message ||
            'Opening Match with the last saved result.',
        })
        setMatchModalInvoice(invoice)
      } finally {
        setRematchingInvoiceId(null)
      }
      return
    }

    setMatchModalInvoice(invoice)
  }

  const handleMatchOrder = async (order, candidates = [], options = {}) => {
    if (!candidates.length && !options.focusInvoice) {
      // Receipted + no PO-touching matchables → Add invoice chooser.
      setGrAddInvoiceChooser({ visible: true, order })
      return
    }

    // Refresh Invoices library so Linked vs Reconciled isn't stale before
    // Finish reconcile / Match & reconcile opens.
    let freshUploaded = uploadedInvoices
    try {
      const refreshed = await dispatch(getUploadedInvoices(venueId))
      if (Array.isArray(refreshed)) {
        freshUploaded = refreshed
      }
    } catch (_) {
      // Fall through with in-memory rows; enrichment from order details still helps.
    }

    const rows = (freshUploaded || []).map(invoice =>
      mapInvoiceToTableRow(invoice),
    )

    const matchState = getGoodsReceiptingMatchActionState(order, rows)
    if (matchState.kind === 'reconciled') {
      SuccessNotification({
        message: 'Already reconciled',
        description:
          'This purchase order already has a reconciled invoice (or is sent to Xero). Showing Reconciled — Match & reconcile is not needed.',
      })
      return
    }

    const focusInvoice = options.focusInvoice || null
    const focusInvoiceId =
      options.focusInvoiceId || focusInvoice?.id || focusInvoice?._id || null

    const effectiveCandidates =
      matchState.candidates?.length > 0
        ? matchState.candidates
        : candidates.length > 0
        ? candidates
        : getMatchableInvoicesForReceiptingOrder(order, rows)

    if (!effectiveCandidates.length && !focusInvoice) {
      if (matchState.kind === 'upload') {
        setGrAddInvoiceChooser({ visible: true, order })
      }
      return
    }

    if (shouldOpenMatchChooserForReceiptingOrder(order, rows)) {
      const chooserInvoices =
        getChooserInvoicesForReceiptingOrder(order, rows) || effectiveCandidates
      setMatchChooser({
        visible: true,
        order,
        invoices: chooserInvoices.length
          ? chooserInvoices
          : effectiveCandidates,
        focusInvoiceId,
      })
      return
    }

    const toOpen =
      (focusInvoice &&
        getMatchableInvoicesForReceiptingOrder(order, rows).some(
          inv =>
            String(inv.id || inv._id) ===
            String(focusInvoice.id || focusInvoice._id),
        ) &&
        focusInvoice) ||
      effectiveCandidates[0]

    if (toOpen) {
      await openMatchInvoiceFromGr(toOpen)
      return
    }

    // Closed-only click: still show the chooser so the PO invoice list is clear.
    const chooserInvoices = getChooserInvoicesForReceiptingOrder(order, rows)
    if (chooserInvoices.length) {
      setMatchChooser({
        visible: true,
        order,
        invoices: chooserInvoices,
        focusInvoiceId,
      })
    }
  }

  const closeGrAddInvoiceChooser = () => {
    setGrAddInvoiceChooser({ visible: false, order: null })
  }

  const handleGrAddInvoiceLinkExisting = () => {
    const order = grAddInvoiceChooser.order
    setGrAddInvoiceChooser({ visible: false, order: null })
    setGrLinkExisting({
      visible: true,
      order,
      selectedInvoiceId: null,
    })
  }

  const handleGrAddInvoiceUploadNew = () => {
    const order = grAddInvoiceChooser.order
    setGrAddInvoiceChooser({ visible: false, order: null })
    setGrUpload({ visible: true, order })
  }

  const closeGrLinkExisting = () => {
    setGrLinkExisting({
      visible: false,
      order: null,
      selectedInvoiceId: null,
    })
  }

  const handleGrLinkExistingBack = () => {
    const order = grLinkExisting.order
    setGrLinkExisting({
      visible: false,
      order: null,
      selectedInvoiceId: null,
    })
    setGrAddInvoiceChooser({ visible: true, order })
  }

  const handleGrLinkExistingUploadNew = () => {
    const order = grLinkExisting.order
    setGrLinkExisting({
      visible: false,
      order: null,
      selectedInvoiceId: null,
    })
    setGrUpload({ visible: true, order })
  }

  const handleGrLinkExistingSelect = invoice => {
    const id = invoice?.id || invoice?._id || null
    setGrLinkExisting(prev => ({
      ...prev,
      selectedInvoiceId: id ? String(id) : null,
    }))
  }

  const refreshAfterGrLinkExisting = async order => {
    const po = String(order?.purchaseOrderNumber || '').trim()
    dispatch(invalidateReceiptingOrdersCache())
    if (venueId && po) {
      try {
        await rematchInvoicesForPurchaseOrders(venueId, [po])
      } catch (error) {
        console.error('Post link-existing rematch failed', error)
      }
    }
    if (venueId) {
      await dispatch(getUploadedInvoices(venueId))
    }
    if (venueId && filterDates?.start && filterDates?.end) {
      const normalizedStart = moment(filterDates.start).format('YYYY-MM-DD')
      const normalizedEnd = moment(filterDates.end).format('YYYY-MM-DD')
      await dispatch(
        fetchReceiptingOrders(venueId, normalizedStart, normalizedEnd),
      )
    }
  }

  const handleGrLinkExistingLinkOnly = async invoice => {
    const order = grLinkExisting.order
    const invoiceId = invoice?.id || invoice?._id
    if (!order || !invoiceId) return

    const poLabel = String(order.purchaseOrderNumber || '').trim() || 'this PO'
    const body = buildGrLinkExistingBody(order, invoice)
    if (!body.purchaseOrderNumber) {
      RejectedNotification({
        message: 'Missing purchase order',
        description: 'This Goods receipting row has no PO number to link to.',
      })
      return
    }

    const isCreditNote = isCreditNoteDocument(invoice)
    setGrLinkExistingSaving(true)
    try {
      const response = await linkInvoiceToPurchaseOrder(invoiceId, body)
      const linked = response?.linked || response?.data?.linked || {}
      if (isCreditNote || linked.creditApplied) {
        SuccessNotification({
          message: 'Credit applied',
          description: getCreditNoteApplySuccessCopy(
            linked.creditPenniesAbs != null
              ? linked.creditPenniesAbs
              : getCreditNoteAbsolutePennies(invoice),
            linked.remainingPennies ?? null,
            { waitingForInvoice: Boolean(linked.waitingForInvoice) },
          ),
        })
        await maybePromptAndCloseCreditRequestAfterCnApply({
          dispatch,
          venueId,
          purchaseOrderNumber:
            poLabel === 'this PO' ? order?.purchaseOrderNumber : poLabel,
          order,
        })
      } else {
        SuccessNotification({
          message: 'Invoice attached',
          description: `Attached to ${poLabel}. ${GR_LINK_EXISTING_COPY.linkOnlySuccess}`,
        })
      }
      closeGrLinkExisting()
      closeGrAddInvoiceChooser()
      await refreshAfterGrLinkExisting(order)
    } catch (error) {
      RejectedNotification({
        message: isCreditNote
          ? 'Could not apply credit note'
          : 'Could not link invoice',
        description:
          error?.response?.data?.message ||
          error?.message ||
          'Please try again.',
      })
    } finally {
      setGrLinkExistingSaving(false)
    }
  }

  const handleGrLinkExistingLinkAndReconcile = async invoice => {
    if (isCreditNoteDocument(invoice)) {
      RejectedNotification({
        message: 'Credit notes do not reconcile alone',
        description: GR_LINK_EXISTING_COPY.creditNoteReconcileDisabled,
      })
      return
    }
    const order = grLinkExisting.order
    const invoiceId = invoice?.id || invoice?._id
    if (!order || !invoiceId) return

    const poLabel = String(order.purchaseOrderNumber || '').trim() || 'this PO'
    const body = buildGrLinkExistingBody(order, invoice)
    if (!body.purchaseOrderNumber) {
      RejectedNotification({
        message: 'Missing purchase order',
        description: 'This Goods receipting row has no PO number to link to.',
      })
      return
    }

    setGrLinkExistingSaving(true)
    let linkedOk = false
    try {
      await linkInvoiceToPurchaseOrder(invoiceId, body)
      linkedOk = true

      const result = await reconcileInvoiceOneClick(invoiceId, {
        force: false,
        purchaseOrderNumber: body.purchaseOrderNumber,
      })

      const fullyDone = result?.invoiceFullyReconciled !== false
      let showedSentSuccess = false
      if (shouldAutoSendAfterReconcile(result)) {
        try {
          const autoSendResult = await dispatch(
            autoSendReconciledInvoiceToXero({
              venue,
              order: {
                ...order,
                orderIds:
                  result?.linked?.orderIds?.length > 0
                    ? result.linked.orderIds
                    : order.orderIds,
              },
              venueSupplier: order.venueSupplier,
              invoiceId,
              invoice,
            }),
          )
          showedSentSuccess = toastPostReconcileXeroAutoSend({
            autoSendResult,
            venue,
            venueSupplier: order.venueSupplier,
            order,
          }).showedSentSuccess
        } catch (xeroError) {
          // Reconciliation succeeded; Xero can be retried independently.
          console.error('Post-reconcile Xero auto-send failed', xeroError)
          toastPostReconcileXeroAutoSend({
            error: xeroError,
            venue,
            venueSupplier: order.venueSupplier,
            order,
          })
        }
      }
      if (result?.alreadyReconciled) {
        SuccessNotification({
          message: 'Already reconciled',
          description:
            'This invoice was already reconciled. Refreshing your list.',
        })
      } else if (!(showedSentSuccess && fullyDone)) {
        SuccessNotification({
          message: fullyDone ? 'Matched & reconciled' : 'PO slice reconciled',
          description: fullyDone
            ? `Attached to ${poLabel} and reconciled. Goods receipting should show the invoice closed.`
            : `Closed ${poLabel} on Goods receipting. More PO slices may still be open on this invoice. ${XERO_AUTO_SEND_PARTIAL_WAIT_COPY}`,
        })
      }

      closeGrLinkExisting()
      closeGrAddInvoiceChooser()
      await refreshAfterGrLinkExisting(order)
    } catch (error) {
      if (isAlreadyReconciledError(error)) {
        SuccessNotification({
          message: 'Already reconciled',
          description:
            'This invoice was already reconciled. Refreshing your list.',
        })
        closeGrLinkExisting()
        closeGrAddInvoiceChooser()
        await refreshAfterGrLinkExisting(order)
        return
      }

      if (isForceReconcileRequiredError(error)) {
        RejectedNotification({
          message: 'Totals are outside tolerance',
          description: linkedOk
            ? `Attached to ${poLabel}, but totals are outside tolerance so it was not auto-reconciled. ${GR_LINK_EXISTING_COPY.linkOnlySuccess}`
            : 'Totals are outside tolerance. Use Link only, then finish on Goods receipting or Invoices.',
        })
        if (linkedOk) {
          closeGrLinkExisting()
          closeGrAddInvoiceChooser()
          await refreshAfterGrLinkExisting(order)
        }
        return
      }

      RejectedNotification({
        message: 'Could not link & reconcile',
        description:
          error?.response?.data?.message ||
          error?.message ||
          'Please try again.',
      })
      if (linkedOk) {
        await refreshAfterGrLinkExisting(order)
      }
    } finally {
      setGrLinkExistingSaving(false)
    }
  }

  const handleGrUploadCancel = () => {
    setGrUpload({ visible: false, order: null })
  }

  const handleGrUploadUseExistingInvoice = invoice => {
    const order = grUpload.order
    const invoiceId = invoice?.id || invoice?._id || null
    setGrUpload({ visible: false, order: null })
    if (!order) return
    setGrLinkExisting({
      visible: true,
      order,
      selectedInvoiceId: invoiceId ? String(invoiceId) : null,
    })
  }

  const handlePoInvoiceClick = async (order, invoice) => {
    const rows =
      invoiceRows?.length > 0
        ? invoiceRows
        : (uploadedInvoices || []).map(row => mapInvoiceToTableRow(row))
    const candidates = getMatchableInvoicesForReceiptingOrder(order, rows)
    await handleMatchOrder(order, candidates, { focusInvoice: invoice })
  }

  const handleGrUploadConfirmed = async () => {
    const order = grUpload.order
    setGrUpload({ visible: false, order: null })
    if (!order?.purchaseOrderNumber || !venueId) return

    SuccessNotification({
      message: 'Invoice uploaded',
      description:
        'Same as Invoices — matching will refresh. You can Match from here when ready.',
    })

    try {
      await rematchInvoicesForPurchaseOrders(venueId, [
        order.purchaseOrderNumber,
      ])
    } catch (error) {
      console.error('Post-upload rematch failed', error)
    }

    const uploaded = await dispatch(getUploadedInvoices(venueId))
    const rows = (
      Array.isArray(uploaded) ? uploaded : uploadedInvoices || []
    ).map(invoice => mapInvoiceToTableRow(invoice))
    const offer = getPostReceiptMatchOffer(order, rows)
    if (offer.kind === 'strong_single' && offer.invoice) {
      await openMatchInvoiceFromGr(offer.invoice)
      return
    }
    if (offer.kind === 'open_match') {
      await handleMatchOrder(order, offer.candidates)
    }
  }

  const handleMatchChooserSelect = async invoice => {
    setMatchChooser({
      visible: false,
      order: null,
      invoices: [],
      focusInvoiceId: null,
    })
    await openMatchInvoiceFromGr(invoice)
  }

  const handleMatchChooserRemove = async invoice => {
    const invoiceId = invoice?.id || invoice?._id
    const order = matchChooser.order
    if (!invoiceId || !venueId || !order) return

    setRemovingChooserInvoiceId(invoiceId)
    try {
      const result = await removeInvoiceFromPurchaseOrder(invoiceId, {
        venueId,
        username: user,
        supplierId: order?.supplier?._id || order?.supplier,
        purchaseOrderNumber: order?.purchaseOrderNumber,
      })
      SuccessNotification({
        message: result?.message || 'Invoice removed from the purchase order',
        description:
          'Matching and Goods Receipting will refresh. If no open leftovers remain, this PO can show Reconciled.',
      })

      const uploaded = await dispatch(getUploadedInvoices(venueId))
      const rows = (
        Array.isArray(uploaded) ? uploaded : uploadedInvoices || []
      ).map(row => mapInvoiceToTableRow(row))

      dispatch(invalidateReceiptingOrdersCache())
      const normalizedStart = moment(filterDates.start).format('YYYY-MM-DD')
      const normalizedEnd = moment(filterDates.end).format('YYYY-MM-DD')
      await dispatch(
        fetchReceiptingOrders(venueId, normalizedStart, normalizedEnd),
      )

      const stillOpen = getMatchableInvoicesForReceiptingOrder(order, rows)
      if (!stillOpen.length) {
        setMatchChooser({
          visible: false,
          order: null,
          invoices: [],
          focusInvoiceId: null,
        })
        return
      }

      setMatchChooser({
        visible: true,
        order,
        invoices: getChooserInvoicesForReceiptingOrder(order, rows),
        focusInvoiceId: null,
      })
    } catch (error) {
      RejectedNotification({
        message: 'Could not remove invoice from PO',
        description:
          error?.response?.data?.message ||
          error?.message ||
          'Please try again.',
      })
    } finally {
      setRemovingChooserInvoiceId(null)
    }
  }

  const receiptSavedNotificationKey = record =>
    `receipt-saved-${record?.supplier?._id || ''}-${
      record?.purchaseOrderNumber || ''
    }`

  /** Food Safety: check this delivery's products (opens Deliveries pre-filled). */
  const renderFoodSafetyDeliveryCheckButton = (record, notificationKey) => {
    if (!canSeeFoodSafety || !venueId || !record?.purchaseOrderNumber) {
      return null
    }
    return (
      <Button
        size='small'
        data-testid='gr-food-safety-delivery-check'
        onClick={() => {
          notification.close(notificationKey)
          history.push(
            buildFoodSafetyDeliveryCheckPath(
              venueId,
              foodSafetyDeliveryCheckTarget(record),
            ),
          )
        }}
      >
        {FOOD_SAFETY_DELIVERY_CHECK_LABEL}
      </Button>
    )
  }

  const receiptSavedNotificationExtras = record => {
    const key = receiptSavedNotificationKey(record)
    const btn = renderFoodSafetyDeliveryCheckButton(record, key)
    return btn ? { key, btn, duration: 8 } : { key }
  }

  /**
   * Step 8 — after Save / Accept: exactly one strong invoice → explicit
   * "Match & reconcile?" toast (never silent). Otherwise open Match / picker.
   */
  const offerMatchAfterReceiptSave = async record => {
    if (!venueId || !record?.purchaseOrderNumber) return

    const uploaded =
      (await dispatch(getUploadedInvoices(venueId))) || uploadedInvoices
    if (!uploaded || uploaded === false) return

    const rows = (Array.isArray(uploaded) ? uploaded : []).map(invoice =>
      mapInvoiceToTableRow(invoice),
    )
    const offer = getPostReceiptMatchOffer(record, rows)

    if (offer.kind === 'strong_single' && offer.invoice) {
      const invoice = offer.invoice
      const key = `post-receipt-match-${invoice.id}`
      const invoiceLabel = invoice.invoiceNumber
        ? `Invoice ${invoice.invoiceNumber}`
        : 'An invoice'
      const foodSafetyButton = renderFoodSafetyDeliveryCheckButton(record, key)
      // One toast: the delivery check sits next to Match & reconcile.
      if (foodSafetyButton) {
        notification.close(receiptSavedNotificationKey(record))
      }
      notification.open({
        key,
        message: 'Match & reconcile?',
        description: `${invoiceLabel} is a strong match for PO ${record.purchaseOrderNumber}. Confirm to link and reconcile — nothing is closed automatically.`,
        duration: 12,
        btn: (
          <NotificationButtons>
            {foodSafetyButton}
            <Button
              type='primary'
              size='small'
              onClick={() => {
                notification.close(key)
                openMatchInvoiceFromGr(invoice)
              }}
            >
              Match & reconcile
            </Button>
          </NotificationButtons>
        ),
      })
      return
    }

    if (offer.kind === 'open_match') {
      await handleMatchOrder(record, offer.candidates)
    }
  }

  const onFullAccept = async (record, actualDeliveryDate = null) => {
    const supplierId = record.supplier._id
    const PONumber = record.purchaseOrderNumber

    // Retrospective edits must go through Save receipt so every line's
    // corrected values (and the audit diff) are explicit — never bulk accept.
    if (isRetroEditActiveFor(record)) {
      RejectedNotification({
        message: 'Use Save receipt',
        description:
          'When editing a completed receipt, save your corrections with Save receipt instead of Accept as ordered.',
      })
      return
    }

    if (isGoodsReceiptingBlocked) {
      openGoodsReceiptingPaywall({
        purchaseOrderNumber: PONumber,
        supplierTitle: record?.supplier?.title || null,
      })
      return
    }

    // Find the current order's products
    let currentOrder = receiptingProducts.find(
      item =>
        item.supplier._id === supplierId &&
        item.purchaseOrderNumber === PONumber,
    )

    // If products not loaded yet (order not expanded), fetch them first
    if (!currentOrder) {
      const fetchedProducts = await dispatch(
        fetchReceiptingProducts(venueId, supplierId, PONumber),
      )
      // Use the fetched data directly
      currentOrder = fetchedProducts
    }

    // If still not found, show error and return
    if (!currentOrder || !currentOrder.orders) {
      console.error('Could not load order products')
      return
    }

    // Chunk 9 — never Full-accept over open short / Ask-for-credit lines.
    const blockingLines = (currentOrder.orders || []).filter(
      lineBlocksGrFullAccept,
    )
    const hasLocalShortDraft = (editedReceipting || []).some(item => {
      if (item?.purchaseOrderNumber !== PONumber) return false
      if (item.supplier !== supplierId && item.supplier?._id !== supplierId) {
        return false
      }
      return Boolean(String(item.error || '').trim())
    })
    if (blockingLines.length || hasLocalShortDraft) {
      RejectedNotification({
        message: 'Can’t Accept as ordered',
        description: GR_ACCEPT_BLOCKED_SHORT_COPY,
      })
      return
    }

    const data = applyActualDeliveryDateToLines(
      currentOrder.orders.map(item => {
        return {
          order: item._id,
          supplier: item.supplier,
          purchaseOrderNumber: item.purchaseOrderNumber,
          status: 'Full accept',
          askForCredit: false,
          placedVia: user,
        }
      }),
      actualDeliveryDate,
    )

    const updateInfo = {
      supplierId,
      PONumber,
      venueId,
      savedBy: user,
      receiptingStatus: 'Full accept',
      supplierDiscount: getSupplierDiscountDraft(record),
    }
    const created = await dispatch(createNewReceipting(data, updateInfo))
    if (created === false) return
    notifyVenueHomeChanged()

    if (!isReconciled(record)) {
      await consumeGoodsReceiptingAllowance()
    }

    // Show success notification
    SuccessNotification({
      message: 'Order Accepted & Saved',
      description:
        'Order has been fully accepted and receipted on Goods receipting (delivery signed off — not the same as invoice reconciled). Refreshing...',
      ...receiptSavedNotificationExtras(record),
    })

    // Refresh the receipting orders list to show updated status
    const normalizedStart = moment(filterDates.start).format('YYYY-MM-DD')
    const normalizedEnd = moment(filterDates.end).format('YYYY-MM-DD')
    await dispatch(
      fetchReceiptingOrders(venueId, normalizedStart, normalizedEnd),
    )
    setSupplierDiscountDrafts(prev => {
      const next = { ...prev }
      delete next[getReceiptingRowKey(record)]
      return next
    })
    await offerMatchAfterReceiptSave(record)
  }

  const closeBulkMarkReceivedModal = useCallback(() => {
    if (bulkProcessing) return
    setBulkModalVisible(false)
    setBulkResults(null)
    setBulkProgress({ done: 0, total: 0 })
  }, [bulkProcessing])

  const runBulkMarkReceived = useCallback(
    async ({ actualDeliveryDate: bulkStampYmd = null } = {}) => {
      if (bulkProcessing || !selectedBulkOrders.length) return

      if (isGoodsReceiptingBlocked) {
        openGoodsReceiptingPaywall({
          purchaseOrderNumber: selectedBulkOrders[0]?.purchaseOrderNumber,
          supplierTitle: selectedBulkOrders[0]?.supplier?.title || null,
        })
        return
      }

      setBulkProcessing(true)
      setBulkResults(null)
      setBulkProgress({ done: 0, total: selectedBulkOrders.length })

      const results = []
      let anySuccess = false

      for (let index = 0; index < selectedBulkOrders.length; index += 1) {
        const record = selectedBulkOrders[index]
        const supplierId = record?.supplier?._id
        const PONumber = record?.purchaseOrderNumber
        const supplierTitle = record?.supplier?.title || ''

        const pushResult = (code, reason) => {
          results.push({
            code,
            reason,
            purchaseOrderNumber: PONumber,
            supplierTitle,
          })
        }

        try {
          if (!isEligibleForBulkMarkReceived(record)) {
            const reason =
              getBulkMarkReceivedDisabledReason(record) || 'Not eligible.'
            let code = BULK_RESULT.SKIPPED_NEEDS_REVIEW
            if (reason.includes('already')) {
              code = BULK_RESULT.SKIPPED_ALREADY_RECEIVED
            } else if (reason.toLowerCase().includes('void')) {
              code = BULK_RESULT.SKIPPED_VOIDED
            } else if (reason.toLowerCase().includes('credit')) {
              code = BULK_RESULT.SKIPPED_CREDIT_WORKFLOW
            }
            pushResult(code, reason)
          } else {
            let currentOrder = receiptingProducts.find(
              item =>
                String(item?.supplier?._id || item?.supplier) ===
                  String(supplierId) && item.purchaseOrderNumber === PONumber,
            )

            if (!currentOrder) {
              const fetchedProducts = await dispatch(
                fetchReceiptingProducts(venueId, supplierId, PONumber),
              )
              currentOrder = fetchedProducts
            }

            const evaluation = evaluateBulkMarkReceivedProducts(
              record,
              currentOrder,
            )
            if (!evaluation.ok) {
              pushResult(evaluation.code, evaluation.reason)
            } else {
              const stampYmd = resolveBulkActualDeliveryDate(
                record,
                bulkStampYmd,
              )
              const data = applyActualDeliveryDateToLines(
                buildBulkFullAcceptPayload(
                  currentOrder.orders,
                  `${user} (bulk historical)`,
                ),
                stampYmd,
              )
              const updateInfo = {
                supplierId,
                PONumber,
                venueId,
                savedBy: user,
                receiptingStatus: 'Full accept',
                supplierDiscount: getSupplierDiscountDraft(record),
              }
              const created = await dispatch(
                createNewReceipting(data, updateInfo),
              )
              if (created === false) {
                pushResult(
                  BULK_RESULT.FAILED,
                  'Save failed — try Accept as ordered on this PO individually.',
                )
              } else {
                anySuccess = true
                if (!isReconciled(record)) {
                  await consumeGoodsReceiptingAllowance()
                }
                pushResult(BULK_RESULT.SUCCESS, 'Marked as received.')
              }
            }
          }
        } catch (error) {
          pushResult(
            BULK_RESULT.FAILED,
            error?.message || 'Unexpected error while receipting.',
          )
        }

        setBulkProgress({ done: index + 1, total: selectedBulkOrders.length })
      }

      if (anySuccess) {
        notifyVenueHomeChanged()
        const normalizedStart = moment(filterDates.start).format('YYYY-MM-DD')
        const normalizedEnd = moment(filterDates.end).format('YYYY-MM-DD')
        await dispatch(
          fetchReceiptingOrders(venueId, normalizedStart, normalizedEnd),
        )
        setBulkSelectedRowKeys([])
      }

      setBulkResults(results)
      setBulkProcessing(false)
    },
    [
      bulkProcessing,
      selectedBulkOrders,
      isGoodsReceiptingBlocked,
      openGoodsReceiptingPaywall,
      receiptingProducts,
      dispatch,
      venueId,
      user,
      getSupplierDiscountDraft,
      consumeGoodsReceiptingAllowance,
      filterDates.start,
      filterDates.end,
    ],
  )

  const onSave = async (
    record,
    saveType = 'reconciliation',
    invoiceMeta = null,
    actualDeliveryDate = null,
  ) => {
    const supplierId = record.supplier._id
    const PONumber = record.purchaseOrderNumber

    if (saveType !== 'cn_request' && isGoodsReceiptingBlocked) {
      openGoodsReceiptingPaywall({
        purchaseOrderNumber: PONumber,
        supplierTitle: record?.supplier?.title || null,
      })
      return
    }

    const retroEdit = isRetroEditActiveFor(record)

    const updateInfo = {
      supplierId,
      PONumber,
      venueId,
      savedBy:
        saveType === 'cn_request'
          ? `Credit Note Request Submitted - ${user}`
          : `Receipt saved - ${user}`,
      saveType: saveType,
      supplierDiscount: getSupplierDiscountDraft(record),
      // Retrospective receipt editing — the slice stamps each line.
      ...(retroEdit
        ? {
            retrospectiveEdit: true,
            retroEditUsername:
              authAccount?.username || authAccount?.emailAddress || '',
          }
        : {}),
    }

    const currentOrder = receiptingProducts?.find(
      item =>
        item?.purchaseOrderNumber === PONumber &&
        String(item?.supplier?._id || item?.supplier) === String(supplierId),
    )
    const lineOrders = currentOrder?.orders || []

    const withActor = item => {
      const askForCredit = resolveAskForCredit(item)
      return {
        ...item,
        askForCredit,
        status:
          item.status === 'Full accept'
            ? item.status
            : getReceiptingLineStatusForCredit(askForCredit),
        placedVia: user,
        requestedBy: user,
      }
    }

    let data = buildSaveReceiptingData({
      editedReceipting,
      weightedItems,
      asOrderedLineIds,
      lineOrders,
      supplierId,
      purchaseOrderNumber: PONumber,
      placedVia: user,
    }).map(withActor)

    updateInfo.receiptingStatus = resolveSaveReceiptingStatus(saveType, data)

    // Optional invoice metadata (legacy attach flows). Save receipt does not require it.
    if (invoiceMeta && invoiceMeta.invoiceNumber && invoiceMeta.invoiceDate) {
      data = data.map(item => ({
        ...item,
        invoiceNumber: invoiceMeta.invoiceNumber,
        invoiceDate: invoiceMeta.invoiceDate,
      }))
    }
    // Physical arrival date — independent of order date / GR timestamp.
    // Modal requires it for new UI; omit keeps legacy callers working.
    data = applyActualDeliveryDateToLines(data, actualDeliveryDate)
    if (!data.length) {
      RejectedNotification({
        message: 'Nothing to save',
        description:
          'Mark lines As ordered or Report Error before saving this receipt. To save a supplier discount only, use Save discount.',
      })
      return
    }

    const created = await dispatch(createNewReceipting(data, updateInfo))
    if (created === false) return
    notifyVenueHomeChanged()

    if (retroEdit) {
      exitRetroEdit(record)
      updateInfo.retrospectivelyEdited = true
    }
    if (actualDeliveryDate) {
      updateInfo.actualDeliveryDate = actualDeliveryDate
    }

    if (saveType !== 'cn_request' && !isReconciled(record)) {
      await consumeGoodsReceiptingAllowance()
    }

    // Find the receipting product and safely access its orders
    const receiptingProduct = receiptingProducts.find(
      item =>
        item.supplier === supplierId && item.purchaseOrderNumber === PONumber,
    )

    if (receiptingProduct && receiptingProduct.orders) {
      const { totalSpend, totalVAT } = getTotalSpendReceiptingWithVAT(
        receiptingProduct.orders,
      )
      updateInfo.totalSpend = totalSpend
      // keep the display-only VAT pair in sync after a save
      const discountPennies = Math.max(
        0,
        Math.round(Number(record.supplierDiscountPennies) || 0),
      )
      updateInfo.totalSpendReceivedVatExPennies = Math.max(
        0,
        totalSpend - totalVAT - discountPennies,
      )
      updateInfo.totalSpendReceivedVatIncPennies = Math.max(
        0,
        totalSpend - discountPennies,
      )
    } else {
      // Fallback to the record's totalSpend if product not found
      updateInfo.totalSpend = record.totalSpend || record.totalSpendOrdered
    }
    const discountDraft = getSupplierDiscountDraft(record)
    updateInfo.supplierDiscountPennies = discountDraft.discountPennies
    updateInfo.supplierDiscountNote = discountDraft.note
    dispatch(updateReceiptingOrder(updateInfo))
    setSupplierDiscountDrafts(prev => {
      const next = { ...prev }
      delete next[getReceiptingRowKey(record)]
      return next
    })

    const fullAcceptCount = data.filter(
      item => item.status === 'Full accept',
    ).length
    const problemCount = data.length - fullAcceptCount

    // Retro corrections are paperwork on an old delivery — no new check offer.
    const savedExtras = retroEdit ? {} : receiptSavedNotificationExtras(record)
    // Show success notification based on save type
    if (saveType === 'cn_request') {
      SuccessNotification({
        message: 'Receipt saved',
        description: `Order receipted and credit request sent where Ask for credit? was ticked. ${CN_DOCUMENT_COPY.askForCreditFollowUp} Refreshing...`,
        ...savedExtras,
      })
    } else if (updateInfo.receiptingStatus === 'Full accept') {
      SuccessNotification({
        message: 'Receipt saved',
        description:
          'All marked lines were Full accept. Order is receipted on Goods receipting (delivery signed off — not the same as invoice reconciled). Refreshing...',
        ...savedExtras,
      })
    } else {
      SuccessNotification({
        message: 'Receipt saved',
        description: `Order receipted with ${fullAcceptCount} As ordered (Full accept) and ${problemCount} reported line${
          problemCount === 1 ? '' : 's'
        }. Receipting is delivery truth — not invoice reconciled. Refreshing...`,
        ...savedExtras,
      })
    }

    if (typeof onReceiptSaved === 'function') {
      onReceiptSaved()
    }

    const clearPoLineEdits = item => {
      const itemSupplierId = item?.supplier?._id || item?.supplier
      const samePo =
        String(itemSupplierId) === String(supplierId) &&
        item?.purchaseOrderNumber === PONumber
      return !samePo
    }

    setEditedReceipting(editedReceipting.filter(clearPoLineEdits))
    setWeightedItems(weightedItems.filter(clearPoLineEdits))
    setAsOrderedLineIds(clearAsOrderedIdsForPo(asOrderedLineIds, lineOrders))
    const search = receiptingOrders.map(order => {
      if (
        supplierId === order.supplier._id &&
        PONumber === order.purchaseOrderNumber
      ) {
        const productData = receiptingProducts?.find(
          item =>
            item.supplier === supplierId &&
            item.purchaseOrderNumber === PONumber,
        )

        // Safety check: if products not loaded, keep original order
        if (!productData || !productData.orders) {
          return order
        }

        const product = productData.orders

        let newPrice = 0
        if (weightedItems && weightedItems[0] && weightedItems[0]?.weight) {
          newPrice = weightedItems[0]?.weight * product[0].price
        } else if (editedReceipting && editedReceipting.length > 0) {
          const editedReceipt = editedReceipting.filter(
            order =>
              order.purchaseOrderNumber === PONumber &&
              order.supplier === supplierId,
          )

          newPrice = editedReceipt[0]?.updatedQuantity * product[0].price
        } else if (
          product[0]?.receipting &&
          product[0].receipting?.updatedQuantity
        ) {
          newPrice = product[0].price * product[0].receipting?.updatedQuantity
        } else {
          newPrice =
            product[0].price * product[0].quantity || record.totalSpendReceived
        }
        const updatedOrder = { ...order, totalSpendReceived: newPrice }
        return updatedOrder
      } else {
        return order
      }
    })
    dispatch(setReceiptingOrders(search))

    // Refresh the receipting orders list to show updated status
    const normalizedStart = moment(filterDates.start).format('YYYY-MM-DD')
    const normalizedEnd = moment(filterDates.end).format('YYYY-MM-DD')
    await dispatch(
      fetchReceiptingOrders(venueId, normalizedStart, normalizedEnd),
    )
    // Retrospective corrections already have invoices in play — don't pop the
    // post-GR Match offer on every historical edit save.
    if (!retroEdit) {
      await offerMatchAfterReceiptSave(record)
    }
  }

  const handleInvoiceMatchedFromGr = async () => {
    setMatchModalInvoice(null)
    setMatchChooser({
      visible: false,
      order: null,
      invoices: [],
      focusInvoiceId: null,
    })
    setGrLinkExisting({
      visible: false,
      order: null,
      selectedInvoiceId: null,
    })
    setGrAddInvoiceChooser({ visible: false, order: null })
    dispatch(invalidateReceiptingOrdersCache())
    await dispatch(getUploadedInvoices(venueId))
    const normalizedStart = moment(filterDates.start).format('YYYY-MM-DD')
    const normalizedEnd = moment(filterDates.end).format('YYYY-MM-DD')
    await dispatch(
      fetchReceiptingOrders(venueId, normalizedStart, normalizedEnd),
    )
  }

  const onMarkDelivered = async (record, actualDeliveryDate = null) => {
    const supplierId = record?.supplier?._id
    const PONumber = record?.purchaseOrderNumber

    if (!supplierId || !PONumber || !actualDeliveryDate) return

    const result = await dispatch(
      markOrderDelivered(venueId, supplierId, PONumber, actualDeliveryDate),
    )

    if (!result) return

    SuccessNotification({
      message: 'Order Marked as Delivered',
      description:
        'Order has been confirmed with the Actual Delivery Date and is now ready for receipting.',
    })

    const normalizedStart = moment(filterDates.start).format('YYYY-MM-DD')
    const normalizedEnd = moment(filterDates.end).format('YYYY-MM-DD')
    await dispatch(
      fetchReceiptingOrders(venueId, normalizedStart, normalizedEnd),
    )
  }

  const handleSaveReconciliationEmailSettings = () => {
    if (!venueId) return
    if (isFreePlan) {
      setPlanLimitVariant('reconciliationEmailReports')
      setShowPlanLimitModal(true)
      return
    }
    const payload = buildReconciliationEmailSettingsPayload({
      emails: reconciliationReportEmails,
      frequency: reconciliationReportFrequency,
    })
    dispatch(editVenue(payload, venueId))
    setShowEmailSettingsSaved(true)
    setTimeout(() => setShowEmailSettingsSaved(false), 2000)
  }

  const handleFreePlanEmailSettingsIntercept = () => {
    if (isFreePlan) {
      setPlanLimitVariant('reconciliationEmailReports')
      setShowPlanLimitModal(true)
    }
  }

  const handleSettingsPanelChange = keys => {
    setSettingsPanelOpen(keys.includes(SETTINGS_PANEL_KEY))
  }

  useEffect(() => {
    if (createdReceipting.length) {
      dispatch(findOrderAndUpdateState(createdReceipting))
    }
  }, [createdReceipting])
  const getExpandedOrder = record => {
    const supplierId = record.supplier._id
    const PONumber = record.purchaseOrderNumber
    const currentOrder = receiptingProducts.find(
      item =>
        item.supplier._id === supplierId &&
        item.purchaseOrderNumber === PONumber,
    )
    if (currentOrder) return
    dispatch(fetchReceiptingProducts(venueId, supplierId, PONumber))
  }

  const expandOrderRow = record => {
    const key = getReceiptingRowKey(record)
    setExpandedRowKeys(prev => (prev.includes(key) ? prev : [...prev, key]))
    getExpandedOrder(record)
  }

  useEffect(() => {
    const po = String(urlSearchQuery || '').trim()
    if (!po || !venueId || !ordersLoaded || isLoading) {
      return undefined
    }
    const loaded = [
      ...(receiptingOrders || []),
      ...(voidedReceiptingOrders || []),
    ]
    const inRange = loaded.some(
      item => String(item.purchaseOrderNumber || '').trim() === po,
    )
    if (inRange) {
      setOutsideDateMessage('')
      setOutsideOrderDate('')
      return undefined
    }
    let cancelled = false
    searchPurchaseOrders(venueId, po)
      .then(results => {
        if (cancelled) return null
        const match = (results || []).find(
          row => String(row.purchaseOrderNumber || '').trim() === po,
        )
        if (!match) {
          setOutsideDateMessage('')
          setOutsideOrderDate('')
          return null
        }
        const usesDelivery = filterDateBasis === 'actualDeliveryDate'
        const orderDate = usesDelivery ? match.deliveryDate : match.orderedDate
        const message = describePurchaseOrderOutsideReceiptingDates({
          purchaseOrderNumber: po,
          orderDate,
          start: filterDates?.start,
          end: filterDates?.end,
          dateBasis: usesDelivery ? 'actualDeliveryDate' : 'orderedDate',
        })
        setOutsideDateMessage(message)
        setOutsideOrderDate(message ? orderDate : '')
        return null
      })
      .catch(() => {
        if (!cancelled) {
          setOutsideDateMessage('')
          setOutsideOrderDate('')
        }
      })
    return () => {
      cancelled = true
    }
  }, [
    urlSearchQuery,
    venueId,
    ordersLoaded,
    isLoading,
    receiptingOrders,
    voidedReceiptingOrders,
    filterDates?.start,
    filterDates?.end,
    filterDateBasis,
  ])

  const openedDeliveryRef = useRef('')
  useEffect(() => {
    const po = String(urlSearchQuery || '').trim()
    if (!po || !ordersLoaded) return
    const order = (receiptingOrders || []).find(
      item => String(item.purchaseOrderNumber || '').trim() === po,
    )
    const back = venueHomeReturnPath(venueId, location.search)
    if (!order) {
      if (back) history.replace(back)
      return
    }
    if (openedDeliveryRef.current === po) return
    openedDeliveryRef.current = po
    expandOrderRow(order)
  }, [
    urlSearchQuery,
    ordersLoaded,
    receiptingOrders,
    venueId,
    location.search,
    history,
  ])

  const beginFirstReceipt = item => {
    const pick = pickAcceptedSuggestedItem(item)
    const po = String(pick?.purchaseOrderNumber || '').trim()
    if (po) {
      setSearchQuery(po)
      setIsPoChecked(true)
      setIsSupplierChecked(false)
      handleStatusFilterChange(FILTER_KEYS.ALL)
    }
    const order = findSuggestedReceiptingOrder(
      excludeVoidedGoodsReceiptingOrders(receiptingOrders),
      pick,
    )
    if (order) expandOrderRow(order)
  }
  const goodsReceiptingEmptyCta = getGoodsReceiptingEmptyCta({
    orders: excludeVoidedGoodsReceiptingOrders(receiptingOrders),
    suggestedItems: suggested?.visibleItems,
    emptyStateCta: guidedSuccess?.emptyState?.cta,
  })
  const beginGuidedEmptyCta = item => {
    if (goodsReceiptingEmptyCta.needsOrderFirst) {
      const path = resolveGoodsReceiptingNeedOrderPath(venueId)
      if (path) history.push(path)
      return
    }
    beginFirstReceipt(item)
  }
  const suggestedEmpty = bindGuidedEmptySuggestedActions({
    venueId,
    featureId: 'goods_receipting',
    suggested,
    onStart: beginGuidedEmptyCta,
  })

  const handleHasVatChange = (treatmentOrChecked, line) => {
    if (!line?._id) return
    setOrderHasVatDraft(prev => ({
      ...prev,
      [String(line._id)]: treatmentOrChecked,
    }))
  }

  const getPendingVatChanges = (lines = []) =>
    lines.filter(line => {
      const orderId = String(line?._id || '')
      if (!orderId) return false
      const draftValue = Object.prototype.hasOwnProperty.call(
        orderHasVatDraft,
        orderId,
      )
        ? orderHasVatDraft[orderId]
        : undefined
      return isOrderHasVatDraftDirty(line, draftValue)
    })

  const handleSaveOrderHasVat = async (parentRecord, lines = []) => {
    const pending = getPendingVatChanges(lines)
    if (!pending.length) return

    const saveKey = getReceiptingRowKey(parentRecord)
    setSavingOrderHasVatKey(saveKey)
    const supplierId = parentRecord?.supplier?._id || parentRecord?.supplier
    const purchaseOrderNumber = parentRecord?.purchaseOrderNumber
    const updates = pending.map(line => {
      const orderId = String(line._id)
      const hasVatDraftValue = Object.prototype.hasOwnProperty.call(
        orderHasVatDraft,
        orderId,
      )
        ? orderHasVatDraft[orderId]
        : undefined
      return buildOrderVatUpdatePayload(line, hasVatDraftValue)
    })

    try {
      const result = await dispatch(
        updateReceiptingOrderHasVat({
          supplierId,
          purchaseOrderNumber,
          updates,
        }),
      )

      const savedIds = (result?.updated || []).map(item => String(item.orderId))
      if (savedIds.length) {
        setOrderHasVatDraft(prev => {
          const next = { ...prev }
          savedIds.forEach(id => {
            delete next[id]
          })
          return next
        })
        SuccessNotification({ message: 'VAT saved' })
      }

      // Re-run invoice matching so Received Totals reflect new VAT treatment.
      if (venueId && purchaseOrderNumber) {
        try {
          await rematchInvoicesForPurchaseOrders(venueId, [purchaseOrderNumber])
        } catch (rematchError) {
          console.error('Post-VAT rematch failed', rematchError)
        }
      }
    } catch (_error) {
      // updateReceiptingOrderHasVat shows RejectedNotification
    } finally {
      setSavingOrderHasVatKey(null)
    }
  }

  const handleExcludeFromGrossProfitToggle = useCallback(
    async line => {
      const venueProduct = findVenueProductForOrderLine(venueProducts, line)
      if (!venueProduct?._id) return

      const confirmed = await promptExcludeFromGrossProfitDuplicateTitle({
        product: venueProduct,
        products: venueProducts,
        excluding: !isVenueProductExcludedFromGrossProfit(venueProduct),
      })
      if (!confirmed) return

      const result = await persistVenueProductExcludeFromGrossProfitToggle({
        dispatch,
        editVenueProduct,
        products: venueProducts,
        venueId,
        productId: venueProduct._id,
      })

      if (!result.ok && result.error) {
        RejectedNotification({
          message: 'Could not save product',
          description: result.error,
        })
      }
    },
    [dispatch, venueId, venueProducts],
  )

  const handleAddUnmatchedLineToShoppingList = useCallback(
    async line => {
      const payload = buildVenueProductCreatePayloadFromGrLine(line, venueId)
      if (!payload) return

      setAddingShoppingListLineId(line?._id || true)
      try {
        const created = await dispatch(
          addVenueProduct(payload, { silent: true }),
        )
        if (!created?._id) {
          RejectedNotification({
            message: 'Could not add to shopping list',
            description:
              'Please try again. If the problem persists, contact support.',
          })
          return
        }
        SuccessNotification({
          message: 'Added to shopping list',
          description: 'You can now exclude this product from Gross Profit.',
        })
      } finally {
        setAddingShoppingListLineId(null)
      }
    },
    [dispatch, venueId],
  )

  const handleSaveSupplierDiscount = useCallback(
    async record => {
      if (!record || !canEditPoSupplierDiscount(record, uploadedInvoices)) {
        RejectedNotification({
          message: 'Discount locked',
          description: isInvoiceReconciledAgainstPurchaseOrder(
            record,
            uploadedInvoices,
          )
            ? 'Supplier discount cannot be edited after an invoice on this purchase order is reconciled.'
            : 'Supplier discount cannot be edited after this order was receipted.',
        })
        return
      }

      const draft = getSupplierDiscountDraft(record)
      if (!isSupplierDiscountDraftDirty(record, draft)) {
        return
      }

      const supplierId = record.supplier._id
      const PONumber = record.purchaseOrderNumber
      const saveKey = getReceiptingRowKey(record)
      setSavingSupplierDiscountKey(saveKey)
      try {
        const adjustment = await dispatch(
          upsertPurchaseOrderSupplierDiscount({
            venueId,
            purchaseOrderNumber: PONumber,
            supplierId,
            discountPennies: draft.discountPennies,
            note: draft.note,
            rematch: true,
          }),
        )
        if (adjustment === false) return

        const linesReceived = Math.max(
          0,
          Math.round(
            Number(
              record?.totalSpendReceivedBeforeDiscount ??
                (Number(record?.totalSpendReceived) || 0) +
                  (Number(record?.supplierDiscountPennies) || 0),
            ) || 0,
          ),
        )
        const nextReceived = Math.max(0, linesReceived - draft.discountPennies)
        dispatch(
          updateReceiptingOrder({
            supplierId,
            PONumber,
            savedBy: record.savedBy,
            receiptingStatus: record.receiptingStatus,
            totalSpend: nextReceived,
            supplierDiscountPennies: draft.discountPennies,
            supplierDiscountNote: draft.note,
            totalSpendReceivedBeforeDiscount: linesReceived,
          }),
        )
        setSupplierDiscountDrafts(prev => {
          const next = { ...prev }
          delete next[saveKey]
          return next
        })
        SuccessNotification({
          message: 'Supplier discount saved',
          description:
            'Receipted order value updated. Invoice matching will use the discounted total.',
        })
        const normalizedStart = moment(filterDates.start).format('YYYY-MM-DD')
        const normalizedEnd = moment(filterDates.end).format('YYYY-MM-DD')
        await dispatch(
          fetchReceiptingOrders(venueId, normalizedStart, normalizedEnd),
        )
      } finally {
        setSavingSupplierDiscountKey(null)
      }
    },
    [
      dispatch,
      filterDates.end,
      filterDates.start,
      getSupplierDiscountDraft,
      uploadedInvoices,
      venueId,
    ],
  )

  const renderExpandedOrder = record => {
    const supplierId = record.supplier._id
    const PONumber = record.purchaseOrderNumber
    const currentOrder = receiptingProducts?.find(
      item =>
        String(item?.supplier?._id || item?.supplier) === String(supplierId) &&
        String(item.purchaseOrderNumber) === String(PONumber),
    )
    const showAppCheckInBanner = shouldShowAppCheckInConfirmBanner(
      currentOrder?.orders,
      record,
    )
    const pendingVatChanges = getPendingVatChanges(currentOrder?.orders || [])
    const saveKey = getReceiptingRowKey(record)
    return receiptingLoading && !currentOrder ? (
      <Center>
        <Spin size={'large'} />
      </Center>
    ) : (
      <ExpandedLinesWrap>
        <OrderFinancialBreakdown
          orders={currentOrder?.orders || []}
          context={{ venueId, supplierId, purchaseOrderNumber: PONumber }}
          receiving
          hidden={venue?.isPricesHidden}
        />
        {showAppCheckInBanner ? (
          <AppCheckInBanner>
            <InfoCircleOutlined />
            <span>{GR_APP_CHECK_IN_COPY.confirmBanner}</span>
          </AppCheckInBanner>
        ) : null}
        <SupplierDiscountPanel
          record={record}
          draft={getSupplierDiscountDraft(record)}
          onChange={next => setSupplierDiscountDraftForRecord(record, next)}
          onSave={handleSaveSupplierDiscount}
          saving={savingSupplierDiscountKey === saveKey}
          uploadedInvoices={uploadedInvoices}
        />
        {pendingVatChanges.length ? (
          <SaveVatBar>
            <span>
              {pendingVatChanges.length} VAT change
              {pendingVatChanges.length === 1 ? '' : 's'} not saved
            </span>
            <Button
              type='primary'
              size='small'
              htmlType='button'
              loading={savingOrderHasVatKey === saveKey}
              onClick={() =>
                handleSaveOrderHasVat(record, currentOrder?.orders || [])
              }
            >
              Save VAT
            </Button>
          </SaveVatBar>
        ) : null}
        <Table
          columns={ProductColumns(
            editedReceipting,
            setEditedReceipting,
            isEditable,
            weightedItems,
            setWeightedItems,
            openHistory,
            asOrderedLineIds,
            setAsOrderedLineIds,
            record,
            orderHasVatDraft,
            handleHasVatChange,
            {
              venueProducts,
              onExcludeFromGrossProfitToggle:
                handleExcludeFromGrossProfitToggle,
              onAddUnmatchedLineToShoppingList:
                handleAddUnmatchedLineToShoppingList,
              addingShoppingListLineId,
              retroEditActive: isRetroEditActiveFor(record),
              venueId,
            },
          )}
          dataSource={currentOrder?.orders}
          pagination={false}
          size='small'
          scroll={{ x: 1280 }}
          rowKey={record => record._id}
        />
      </ExpandedLinesWrap>
    )
  }

  const openHistory = orderId => {
    setHistoryModalShow(true)
    dispatch(getHistory(orderId))
  }

  const parseHistoryInfo = (item, index, array) => {
    const date = moment(item.createdAt).format('DD-MM-YYYY')
    const time = moment(item.createdAt).format('HH:mm')
    const info = []
    for (const key in item) {
      switch (key) {
        case 'updatedQuantity': {
          if (!index) {
            info.push(
              `Change quantity from ${
                item.order?.orderedQuantity || item.order?.quantity
              } to ${item[key]}`,
            )
          } else {
            info.push(
              `Change quantity from ${
                array[index - 1].updatedQuantity || item.orderedQuantity
              } to ${item[key]}`,
            )
          }
          break
        }
        case 'updatedPrice': {
          if (!index) {
            info.push(
              `Change price from ${
                item.order?.orderedPrice || item.order?.price
              } to ${item[key]}`,
            )
          } else {
            info.push(
              `Change price from ${(
                (array[index - 1].updatedPrice || item.orderedPrice) / 100
              ).toFixed(2)} to ${(item[key] / 100).toFixed(2)}`,
            )
          }
          break
        }
        case 'updatedSku': {
          if (!index) {
            info.push(
              `Change sku from ${
                item.order?.orderedSku || item.order?.sku
              } to ${item[key]}`,
            )
          } else {
            info.push(
              `Change sku from ${
                array[index - 1].updatedSku || item.orderedSku
              } to ${item[key]}`,
            )
          }
          break
        }
        case 'updatedSize': {
          if (!index) {
            info.push(
              `Change size from ${
                item.order?.orderedSize || item.order?.size
              } to ${item[key]}`,
            )
          } else {
            info.push(
              `Change size from ${
                array[index - 1].updatedSize || item.orderedSize
              } to ${item[key]}`,
            )
          }
          break
        }
        case 'updatedTitle': {
          if (!index) {
            info.push(
              `Change title from ${
                item.order?.orderedTitle || item.order?.title
              } to ${item[key]}`,
            )
          } else {
            info.push(
              `Change title from ${
                array[index - 1].updatedTitle || item.orderedTitle
              } to ${item[key]}`,
            )
          }
          break
        }
      }
    }

    return (
      <Panel
        key={item._id}
        header={
          item.error
            ? `${item.placedVia} reported "${item.error}" on ${date} ${time}`
            : `${item.placedVia} accepted on ${date} ${time}`
        }
      >
        {info.map((line, lineIndex) => (
          <p key={`${lineIndex}-${line}`}>{line}</p>
        ))}
      </Panel>
    )
  }

  return (
    <>
      <Prompt
        when={
          !!(
            editedReceipting.length ||
            weightedItems.length ||
            asOrderedLineIds.length ||
            Object.keys(supplierDiscountDrafts).length
          )
        }
        message='You have unsaved changes, are you sure you want to leave?'
      />
      <div style={{ flex: '1 1 100%', minWidth: 0, maxWidth: '100%' }}>
        {venue?.xeroConnectionExpired && (
          <WarningBanner>
            ⚠️ Heads up! Your Xero Connection has Expired - Please Reconnect to
            Keep Using This Feature
          </WarningBanner>
        )}
        {embedded ? null : (
          <>
            <ThreeWayMatchEducation tab='receipting' venueId={venueId} />
            <TopCardsWrapper>
              <FiltersCard>
                <FiltersCardContent>
                  <ReconciliationHealthPanel
                    venueId={venueId}
                    healthSummary={healthSummary}
                    filterDates={filterDates}
                    activeFilter={statusFilter}
                    onFilterChange={handleStatusFilterChange}
                    orphanInvoiceCount={
                      invoiceHealth.orphanInvoices || orphanInvoiceCount
                    }
                    readyToReconcileCount={
                      invoiceHealth.readyToReconcile || readyToReconcileCount
                    }
                    openCreditRequestCount={openCreditRequestCount}
                    invoiceHealth={invoiceHealth}
                    invoiceHealthItems={invoiceHealthItems}
                    ordersLoaded={ordersLoaded}
                    autoExpandSignal={urlStatusFilter}
                  />
                  <FilterWrapper>
                    <ReceiptingFilter
                      venueId={venueId}
                      receiptingOrders={receiptingOrders}
                      isSupplierChecked={isSupplierChecked}
                      setIsSupplierChecked={setIsSupplierChecked}
                      isPoChecked={isPoChecked}
                      setIsPoChecked={setIsPoChecked}
                      setSearchQuery={setSearchQuery}
                      searchQuery={searchQuery}
                      setIsEmptySearch={setIsEmptySearch}
                      isEmptySearch={isEmptySearch}
                    />
                  </FilterWrapper>
                  <StyledSettingsCollapse
                    bordered={false}
                    activeKey={settingsPanelOpen ? [SETTINGS_PANEL_KEY] : []}
                    onChange={handleSettingsPanelChange}
                  >
                    <Panel
                      header='Xero auto-send & email reminders'
                      key={SETTINGS_PANEL_KEY}
                    >
                      <SettingsContent>
                        <ToggleSection>
                          <Container>
                            <Label>{XERO_AUTO_SEND_TOGGLE_LABEL}</Label>
                            <Switch
                              disabled={
                                editLoading ||
                                !venue?.xeroConnection?.accessToken ||
                                Boolean(venue?.xeroConnectionExpired)
                              }
                              onChange={async event => {
                                if (
                                  !venue?.xeroConnection?.accessToken ||
                                  venue?.xeroConnectionExpired
                                ) {
                                  return
                                }
                                setEditLoading(true)
                                await dispatch(
                                  editVenue(
                                    buildXeroAutoSendVenueUpdate(event),
                                    venueId,
                                  ),
                                )
                                setEditLoading(false)
                              }}
                              checked={automaticSendToXero}
                            />
                            {editLoading && (
                              <Spin
                                size='default'
                                style={{ marginLeft: '12px' }}
                              />
                            )}
                          </Container>
                          <Label>
                            {XERO_AUTO_SEND_BODY} {XERO_AUTO_SEND_SUPPLIER_HINT}{' '}
                            <Link to={buildVenueSuppliersPath(venueId)}>
                              Open Your Suppliers
                            </Link>
                            {' · '}
                            <Link to={buildIntegrationsPath(venueId)}>
                              Manage in Integrations
                            </Link>
                            .
                          </Label>
                          {shouldShowXeroManualSendHint({
                            autoSendEnabled: automaticSendToXero,
                            xeroConnected: Boolean(
                              venue?.xeroConnection?.accessToken,
                            ),
                            xeroExpired: Boolean(venue?.xeroConnectionExpired),
                          }) ? (
                            <Label style={{ marginTop: 8, fontWeight: 600 }}>
                              {XERO_AUTO_SEND_MANUAL_SEND_HINT}
                            </Label>
                          ) : null}
                          {venue?.xeroConnectionExpired ? (
                            <Label style={{ color: '#d48806', marginTop: 8 }}>
                              {XERO_AUTO_SEND_REQUIRES_RECONNECT}
                            </Label>
                          ) : !venue?.xeroConnection?.accessToken ? (
                            <Label style={{ color: '#096dd9', marginTop: 8 }}>
                              {XERO_AUTO_SEND_REQUIRES_CONNECTION}
                            </Label>
                          ) : null}
                        </ToggleSection>
                        <ToggleDivider />
                        <EmailSettingsCard>
                          <EmailSettingsHeader>
                            <EmailSettingsTitle>
                              Email Reconciliation Reminder
                            </EmailSettingsTitle>
                            <EmailSettingsSubtitle>
                              Send a weekly or monthly reminder email for
                              outstanding receipting actions.
                            </EmailSettingsSubtitle>
                          </EmailSettingsHeader>
                          <EmailSettingsHint>
                            Primary owner included by default. Weekly reminders
                            are sent Monday mornings.
                          </EmailSettingsHint>
                          <EmailSettingsContent
                            onClick={handleFreePlanEmailSettingsIntercept}
                            onFocusCapture={
                              handleFreePlanEmailSettingsIntercept
                            }
                          >
                            <EmailSettingsRow>
                              <EmailInputSection
                                style={{ flex: 1, minWidth: 0 }}
                              >
                                <EmailInputLabel>
                                  Email Recipients
                                </EmailInputLabel>
                                <ReactMultiEmail
                                  placeholder='Enter email addresses'
                                  emails={reconciliationReportEmails}
                                  style={{ margin: '0px' }}
                                  onChange={emails => {
                                    setReconciliationReportEmails(emails)
                                  }}
                                  validateEmail={email => isEmail(email)}
                                  getLabel={(email, index, removeEmail) => (
                                    <InnerDiv data-tag key={index}>
                                      {email}
                                      <span
                                        data-tag-handle
                                        onClick={() => removeEmail(index)}
                                      >
                                        ×
                                      </span>
                                    </InnerDiv>
                                  )}
                                />
                              </EmailInputSection>
                              <EmailInputSection
                                style={{ flexShrink: 0, width: 200 }}
                              >
                                <EmailInputLabel>
                                  Report Frequency{' '}
                                  <Tooltip
                                    title={
                                      <>
                                        <div>
                                          <strong>Weekly:</strong> Last full
                                          Monday-Sunday. Reminder sent Monday
                                          morning.
                                        </div>
                                        <div>
                                          <strong>Monthly:</strong> Previous
                                          calendar month. Reminder sent first
                                          Monday of the month.
                                        </div>
                                      </>
                                    }
                                  >
                                    <InfoCircleOutlined
                                      style={{
                                        marginLeft: 4,
                                        color: '#1890ff',
                                      }}
                                    />
                                  </Tooltip>
                                </EmailInputLabel>
                                <Select
                                  value={reconciliationReportFrequency}
                                  onChange={value =>
                                    setReconciliationReportFrequency(value)
                                  }
                                  style={{ width: '100%' }}
                                >
                                  <Option value='none'>None</Option>
                                  <Option value='weekly'>Weekly</Option>
                                  <Option value='monthly'>Monthly</Option>
                                </Select>
                              </EmailInputSection>
                            </EmailSettingsRow>
                            <SaveButtonWrapper>
                              {showEmailSettingsSaved ? (
                                <SavedIndicator>
                                  <span>✓ Saved</span>
                                </SavedIndicator>
                              ) : (
                                <Button
                                  type='primary'
                                  onClick={
                                    handleSaveReconciliationEmailSettings
                                  }
                                >
                                  Save
                                </Button>
                              )}
                            </SaveButtonWrapper>
                            {isFreePlan && (
                              <EmailSettingsOverlay
                                tabIndex={0}
                                aria-hidden='true'
                              />
                            )}
                          </EmailSettingsContent>
                        </EmailSettingsCard>
                      </SettingsContent>
                    </Panel>
                  </StyledSettingsCollapse>
                </FiltersCardContent>
              </FiltersCard>
            </TopCardsWrapper>
          </>
        )}
        {(() => {
          const ordersColumnsResult = OrdersColumns(
            editedReceipting,
            weightedItems,
            asOrderedLineIds,
            onSave,
            onFullAccept,
            onMarkDelivered,
            receiptingProducts,
            setOrdersToAdding,
            venueId,
            setModalShow,
            venue.dataplusIntegration,
            setInvoiceModalData,
            uploadedInvoices,
            expandOrderRow,
            invoiceRows,
            handleMatchOrder,
            rematchingInvoiceId,
            handlePoInvoiceClick,
            record => {
              const supplierId = record?.supplier?._id
              const po = record?.purchaseOrderNumber
              const clearPo = item => {
                const itemSupplierId = item?.supplier?._id || item?.supplier
                return !(
                  String(itemSupplierId) === String(supplierId) &&
                  item?.purchaseOrderNumber === po
                )
              }
              setEditedReceipting(prev => prev.filter(clearPo))
              setWeightedItems(prev => prev.filter(clearPo))
              const productBundle = receiptingProducts?.find(item => {
                const itemSupplierId = item?.supplier?._id || item?.supplier
                return (
                  String(itemSupplierId) === String(supplierId) &&
                  item.purchaseOrderNumber === po
                )
              })
              if (productBundle?.orders?.length) {
                setAsOrderedLineIds(prev =>
                  clearAsOrderedIdsForPo(prev, productBundle.orders),
                )
              }
              setExpandedRowKeys(prev =>
                prev.filter(k => !isReceiptingRowKeyForPo(k, po, supplierId)),
              )
              handleStatusFilterChange(FILTER_KEYS.VOIDED)
            },
            () => {
              handleStatusFilterChange(FILTER_KEYS.ALL)
            },
            startRetroEdit,
            isRetroEditActiveFor,
          )
          return (
            <>
              {isLoading && receiptingOrders.length === 0 ? (
                <OrdersLoadingState>
                  <Spin size='large' />
                  <OrdersLoadingText>
                    Loading goods receipting orders…
                  </OrdersLoadingText>
                  <OrdersLoadingHint>
                    This can take a few seconds — your orders have not
                    disappeared.
                  </OrdersLoadingHint>
                </OrdersLoadingState>
              ) : (
                <ReceiptingTableWrapper>
                  <ReceiptPriceGuidance venueId={venueId} />
                  {outsideDateMessage ? (
                    <Alert
                      type='info'
                      showIcon
                      message={outsideDateMessage}
                      description={
                        outsideOrderDate ? (
                          <Button
                            type='link'
                            style={{ padding: 0, height: 'auto' }}
                            onClick={showOutsideOrder}
                          >
                            Show this order
                          </Button>
                        ) : null
                      }
                      style={{ marginBottom: 12 }}
                    />
                  ) : null}
                  {showGoodsReceiptingLimitBanner &&
                  goodsReceiptingLimitCopy ? (
                    <div
                      data-testid='goods-receipting-limit-banner'
                      style={{ marginBottom: 16 }}
                    >
                      <GoodsReceiptingLimitUpsell
                        copy={goodsReceiptingLimitCopy}
                        plan={currentPlan}
                      />
                    </div>
                  ) : null}
                  {statusFilter !== FILTER_KEYS.VOIDED ? (
                    <BulkActionBar>
                      <BulkActionCount>
                        {bulkSelectedRowKeys.length} selected
                        {eligibleBulkOrders.length
                          ? ` · ${eligibleBulkOrders.length} eligible in current filters`
                          : ''}
                      </BulkActionCount>
                      <BulkActionButtons>
                        <Button
                          size='small'
                          disabled={
                            !eligibleBulkOrders.length || bulkProcessing
                          }
                          onClick={() =>
                            setBulkSelectedRowKeys(
                              eligibleBulkOrders.map(getBulkOrderSelectionKey),
                            )
                          }
                        >
                          Select all {eligibleBulkOrders.length} matching
                          filters
                        </Button>
                        <Button
                          size='small'
                          disabled={
                            !bulkSelectedRowKeys.length || bulkProcessing
                          }
                          onClick={() => setBulkSelectedRowKeys([])}
                        >
                          Clear selection
                        </Button>
                        <Button
                          type='primary'
                          size='small'
                          disabled={
                            !bulkSelectedRowKeys.length || bulkProcessing
                          }
                          onClick={() => {
                            setBulkResults(null)
                            setBulkModalVisible(true)
                          }}
                        >
                          {BULK_MARK_RECEIVED_LABEL}
                        </Button>
                      </BulkActionButtons>
                    </BulkActionBar>
                  ) : null}
                  <StyledTable
                    key={`receipting-table-${statusFilter}-${filteredOrders.length}`}
                    columns={ordersColumnsResult.columns}
                    dataSource={filteredOrders}
                    loading={isLoading}
                    rowSelection={
                      statusFilter === FILTER_KEYS.VOIDED
                        ? null
                        : {
                            selectedRowKeys: bulkSelectedRowKeys,
                            onChange: keys => {
                              setBulkSelectedRowKeys(
                                (keys || []).filter(key =>
                                  eligibleBulkKeySet.has(key),
                                ),
                              )
                            },
                            getCheckboxProps: record => {
                              const disabled =
                                !isEligibleForBulkMarkReceived(record)
                              return {
                                disabled,
                                title: disabled
                                  ? getBulkMarkReceivedDisabledReason(record)
                                  : undefined,
                              }
                            },
                            // Ant Design 3: select current page only via header checkbox
                            hideDefaultSelections: true,
                            selections: [
                              {
                                key: 'all-filtered',
                                text: `Select all ${eligibleBulkOrders.length} matching filters`,
                                onSelect: () =>
                                  setBulkSelectedRowKeys(
                                    eligibleBulkOrders.map(
                                      getBulkOrderSelectionKey,
                                    ),
                                  ),
                              },
                              {
                                key: 'clear',
                                text: 'Clear selection',
                                onSelect: () => setBulkSelectedRowKeys([]),
                              },
                            ],
                          }
                    }
                    locale={{
                      emptyText: isLoading ? (
                        'Loading orders…'
                      ) : showGoodsReceiptingRangeEmpty ? (
                        <GrowthEngineFeatureEmptyState
                          featureId='goods_receipting'
                          title={GOODS_RECEIPTING_RANGE_EMPTY_COPY.title}
                          body={GOODS_RECEIPTING_RANGE_EMPTY_COPY.body}
                          ctaLabel={GOODS_RECEIPTING_RANGE_EMPTY_COPY.ctaLabel}
                          onCta={widenGoodsReceiptingDates}
                        />
                      ) : showGoodsReceiptingGuidedEmpty ? (
                        <GrowthEngineFeatureEmptyState
                          featureId='goods_receipting'
                          title={guidedSuccess.emptyState.title}
                          body={guidedSuccess.emptyState.body}
                          valueLine={guidedSuccess.emptyState.valueLine}
                          estimatedMinutes={
                            guidedSuccess.emptyState.estimatedMinutes
                          }
                          ctaLabel={goodsReceiptingEmptyCta.label}
                          suggestedLabel='Start with a delivery that is not checked in'
                          onCta={suggestedEmpty.onCta}
                          suggestedItems={suggestedEmpty.suggestedItems}
                          onSuggestedItem={suggestedEmpty.onSuggestedItem}
                          onSuggestedEdit={suggestedEmpty.onSuggestedEdit}
                          onRejectSuggested={suggestedEmpty.onRejectSuggested}
                        />
                      ) : showGoodsReceiptingLimitEmpty &&
                        goodsReceiptingLimitCopy ? (
                        <GoodsReceiptingLimitUpsell
                          copy={goodsReceiptingLimitCopy}
                          plan={currentPlan}
                        />
                      ) : (
                        tableEmptyText
                      ),
                    }}
                    expandedRowRender={renderExpandedOrder}
                    expandedRowKeys={expandedRowKeys}
                    pagination={{
                      position: 'both',
                      hideOnSinglePage: true,
                      showSizeChanger: false,
                      size: 'default',
                    }}
                    scroll={RESPONSIVE_TABLE_SCROLL}
                    onExpand={(expanded, record) => {
                      const key = getReceiptingRowKey(record)
                      if (expanded) {
                        setExpandedRowKeys(prev =>
                          prev.includes(key) ? prev : [...prev, key],
                        )
                        getExpandedOrder(record)
                      } else {
                        setExpandedRowKeys(prev =>
                          prev.filter(rowKey => rowKey !== key),
                        )
                      }
                    }}
                    rowKey={record => getReceiptingRowKey(record)}
                    bordered
                    size='middle'
                  />
                </ReceiptingTableWrapper>
              )}
              <BulkMarkReceivedModal
                visible={bulkModalVisible}
                orders={selectedBulkOrders}
                venueTitle={venue?.title || ''}
                processing={bulkProcessing}
                progress={bulkProgress}
                results={bulkResults}
                onCancel={closeBulkMarkReceivedModal}
                onConfirm={runBulkMarkReceived}
              />
              {ordersColumnsResult.modal}
              <GrMatchInvoiceChooserModal
                visible={matchChooser.visible}
                order={matchChooser.order}
                invoices={matchChooser.invoices}
                focusInvoiceId={matchChooser.focusInvoiceId}
                onSelect={handleMatchChooserSelect}
                onRemove={handleMatchChooserRemove}
                removingInvoiceId={removingChooserInvoiceId}
                onCancel={() =>
                  setMatchChooser({
                    visible: false,
                    order: null,
                    invoices: [],
                    focusInvoiceId: null,
                  })
                }
              />
              <GrAddInvoiceChooserModal
                visible={grAddInvoiceChooser.visible}
                order={grAddInvoiceChooser.order}
                onCancel={closeGrAddInvoiceChooser}
                onLinkExisting={handleGrAddInvoiceLinkExisting}
                onUploadNew={handleGrAddInvoiceUploadNew}
              />
              <GrLinkExistingInvoiceModal
                visible={grLinkExisting.visible}
                venueId={venueId}
                order={grLinkExisting.order}
                invoiceRows={invoiceRows}
                selectedInvoiceId={grLinkExisting.selectedInvoiceId}
                onSelectInvoice={handleGrLinkExistingSelect}
                onCancel={closeGrLinkExisting}
                onBack={handleGrLinkExistingBack}
                onUploadNew={handleGrLinkExistingUploadNew}
                onLinkOnly={handleGrLinkExistingLinkOnly}
                onLinkAndReconcile={handleGrLinkExistingLinkAndReconcile}
                confirmLoading={grLinkExistingSaving}
              />
              <GrUploadInvoiceModal
                visible={grUpload.visible}
                venueId={venueId}
                order={grUpload.order}
                onCancel={handleGrUploadCancel}
                onUploaded={handleGrUploadConfirmed}
                onUseExistingInvoice={handleGrUploadUseExistingInvoice}
              />
              <MatchInvoiceModal
                visible={Boolean(matchModalInvoice)}
                venueId={venueId}
                invoice={matchModalInvoice}
                username={user}
                uploadedInvoices={invoiceRows}
                onCancel={() => setMatchModalInvoice(null)}
                onLinked={handleInvoiceMatchedFromGr}
                onReconciled={handleInvoiceMatchedFromGr}
                onRemoved={handleInvoiceMatchedFromGr}
              />
            </>
          )
        })()}
      </div>
      <Modal
        width={'60%'}
        title={'Add product to order'}
        okText={'Add product'}
        visible={modalShow}
        okButtonProps={{
          disabled:
            ordersToAdding.quantity === '' ||
            ordersToAdding.quantity === undefined ||
            ordersToAdding.quantity === '0',
        }}
        onCancel={() => {
          setOrdersToAdding({})
          setModalShow(false)
        }}
        onOk={async () => {
          const ok = await dispatch(addProduct(ordersToAdding))
          if (!ok) {
            RejectedNotification({
              message: 'Could not add product',
              description:
                'The product was not added. Check the order is still open for receipting, then try again.',
            })
            // Keep the modal open (antd closes on resolved onOk promises).
            throw new Error('add_product_failed')
          }
          setOrdersToAdding({})
          setModalShow(false)
          SuccessNotification({
            message: 'Product added',
            description:
              'The line was added to this order. Ordered amounts have been refreshed.',
          })
          if (venueId) {
            await dispatch(getUploadedInvoices(venueId))
          }
        }}
        confirmLoading={isLoading}
      >
        <AddProductModal
          ordersToAdding={ordersToAdding}
          setOrdersToAdding={setOrdersToAdding}
        />
      </Modal>
      <AtttachInvoiceModal
        open={!!invoiceModalData}
        order={invoiceModalData}
        onClose={() => setInvoiceModalData(null)}
      />
      <Modal
        width={'50%'}
        title={'Order changes history'}
        footer={null}
        visible={historyModalShow}
        onCancel={() => setHistoryModalShow(false)}
      >
        {historyLoading ? (
          <Center>
            <Spin size={'large'} />
          </Center>
        ) : (
          <Collapse>
            {receiptingHistory.map((item, index, array) =>
              parseHistoryInfo(item, index, array),
            )}
          </Collapse>
        )}
      </Modal>
      {showPlanLimitModal && (
        <PlanLimitModal
          showLimitModal={showPlanLimitModal}
          setShowLimitModal={setShowPlanLimitModal}
          variant={planLimitVariant}
          plan={currentPlan}
          copy={
            planLimitVariant === 'goodsReceiptingLimit'
              ? goodsReceiptingLimitCopy
              : undefined
          }
          recommendation={
            planLimitVariant === 'goodsReceiptingLimit'
              ? growthEngineRecommendation
              : undefined
          }
          guidedSuccess={
            planLimitVariant === 'goodsReceiptingLimit'
              ? guidedSuccess
              : undefined
          }
        />
      )}
    </>
  )
}

const StyledTable = styled(Table)`
  /* The orders list scrolls sideways. Keep an open order's lines in the
     visible slice of that list, with their own left-right bar. */
  &
    > .ant-spin-nested-loading
    > .ant-spin-container
    > .ant-table
    > .ant-table-content
    > .ant-table-scroll
    > .ant-table-body {
    container-type: inline-size;
    container-name: receipting-orders;
  }

  /* Prefer fitting at 1024+ / 1440; visible scrollbar only if still overflowing */
  &.ant-table-wrapper,
  & > .ant-spin-nested-loading,
  & > .ant-spin-nested-loading > .ant-spin-container,
  & > .ant-spin-nested-loading > .ant-spin-container > .ant-table,
  &
    > .ant-spin-nested-loading
    > .ant-spin-container
    > .ant-table
    > .ant-table-content {
    max-width: 100%;
  }

  /* Only the parent orders table — do not crush nested line-item tables */
  &
    > .ant-spin-nested-loading
    > .ant-spin-container
    > .ant-table
    > .ant-table-content
    > table,
  &
    > .ant-spin-nested-loading
    > .ant-spin-container
    > .ant-table
    > .ant-table-scroll
    > .ant-table-header
    > table,
  &
    > .ant-spin-nested-loading
    > .ant-spin-container
    > .ant-table
    > .ant-table-scroll
    > .ant-table-body
    > table {
    width: 100% !important;
    table-layout: fixed;
  }

  .ant-table-thead {
    white-space: nowrap;
  }
  .ant-table-thead > tr > th {
    padding: 8px 6px;
    font-size: 12px;
    line-height: 1.25;
    white-space: normal;
    word-break: break-word;
    overflow-wrap: anywhere;
  }
  .ant-table-tbody > tr > td {
    padding: 8px 6px;
    font-size: 12px;
    vertical-align: top;
    word-break: keep-all;
    overflow-wrap: normal;
  }
  .ant-table-tbody > tr > td.restrict-shrink:not(.supplier-col) {
    white-space: nowrap;
  }
  .ant-table-tbody > tr > td.invoice-status-col,
  .ant-table-thead > tr > th.invoice-status-col,
  .ant-table-tbody > tr > td.receipting-status-col,
  .ant-table-thead > tr > th.receipting-status-col,
  .ant-table-tbody > tr > td.last-edit-col,
  .ant-table-thead > tr > th.last-edit-col,
  .ant-table-tbody > tr > td.gr-actions-col,
  .ant-table-thead > tr > th.gr-actions-col,
  .ant-table-tbody > tr > td.gr-actions-cell {
    white-space: normal;
    overflow: hidden;
  }
  /* Keep parent Actions reachable when the orders table must scroll */
  .ant-table-thead > tr > th.gr-actions-col,
  .ant-table-tbody > tr > td.gr-actions-cell {
    position: sticky;
    right: 0;
    z-index: 2;
    background: #fff;
    box-shadow: -6px 0 8px -6px rgba(0, 0, 0, 0.18);
  }
  .ant-table-tbody > tr > td.gr-actions-cell {
    vertical-align: top;
    background: #fafafa;
  }
  .ant-table-tbody > tr.ant-table-expanded-row > td {
    vertical-align: top;
    padding: 8px;
    /* Expanded cell must not clip the nested product table */
    overflow: visible;
    position: relative;
    z-index: 1;
  }

  ${antdTableHorizontalScroll}
`

const BulkActionBar = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 8px 16px;
  margin-bottom: 12px;
  padding: 10px 12px;
  background: #f6ffed;
  border: 1px solid #b7eb8f;
  border-radius: 4px;
`

const BulkActionCount = styled.div`
  font-size: 13px;
  color: #135200;
  font-weight: 500;
`

const BulkActionButtons = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
`

const ReceiptingTableWrapper = styled.div`
  width: 100%;
  min-width: 0;
  max-width: 100%;
  ${visibleHorizontalScroll}
`

const OrdersLoadingState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 280px;
  padding: 48px 24px;
  background: #fafafa;
  border: 1px solid #f0f0f0;
  border-radius: 8px;
`

const OrdersLoadingText = styled.div`
  margin-top: 16px;
  font-size: 16px;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.85);
`

const OrdersLoadingHint = styled.div`
  margin-top: 6px;
  font-size: 13px;
  color: rgba(0, 0, 0, 0.45);
  text-align: center;
  max-width: 360px;
`

const ExpandedLinesWrap = styled.div`
  position: sticky;
  left: 0;
  z-index: 1;
  box-sizing: border-box;
  width: 100cqw;
  max-width: 100cqw;
  min-width: 0;
  ${visibleHorizontalScroll}
  ${antdTableHorizontalScroll}

  /* Nested product table should size to its columns and scroll, not collapse */
  .ant-table-wrapper,
  .ant-spin-nested-loading,
  .ant-spin-container,
  .ant-table,
  .ant-table-content,
  .ant-table-scroll,
  .ant-table-body {
    max-width: 100%;
  }

  .ant-table table {
    table-layout: auto;
  }

  .excludeFromGpColumn {
    min-width: 110px !important;
    width: 110px;
    padding-left: 8px;
    padding-right: 12px;
    text-align: center;
  }

  .ant-table-thead > tr > th.gr-line-actions-col,
  .ant-table-tbody > tr > td.gr-line-actions-col {
    background: #fff;
  }
`

const SaveVatBar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin: 0 0 12px;
  padding: 8px 12px;
  border-radius: 6px;
  border: 1px solid #ffd591;
  background: #fff7e6;
  font-size: 13px;
`

const AppCheckInBanner = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin: 0 0 12px;
  padding: 10px 12px;
  border-radius: 6px;
  border: 1px solid #91d5ff;
  background: #e6f7ff;
  color: rgba(0, 0, 0, 0.75);
  font-size: 13px;
  line-height: 1.4;
`

const WarningBanner = styled.div`
  background-color: #fffbe6;
  color: #ad8b00;
  border: 1px solid #ffe58f;
  border-radius: 6px;
  padding: 12px;
  margin: 8px 0 24px 0;
  font-size: 14px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
`

const TopCardsWrapper = styled.div`
  display: flex;
  gap: 24px;
  align-items: flex-start;
  margin-bottom: 24px;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`

const FiltersCard = styled.div`
  background: #ffffff;
  border: 1px solid rgba(0, 0, 0, 0.06);
  border-radius: 12px;
  padding: 24px;
  flex: 1;
  min-width: 0;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  display: flex;
  flex-direction: column;

  @media (max-width: 768px) {
    width: 100%;
  }
`

const FiltersCardContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  flex: 1;
`

const FilterWrapper = styled.div`
  /* Override ReceiptingFilter's margin-bottom */
  > div {
    margin-bottom: 0 !important;
    overflow: visible;
    flex-wrap: wrap !important;
    gap: 12px !important;
  }

  /* Ensure all filter elements stay within bounds and wrap */
  > div > * {
    flex-shrink: 1;
    min-width: 0;
    max-width: 100%;
  }

  /* Actual Delivery Date basis select must stay visible (antd v3 Select) */
  > div > *:first-child {
    flex-shrink: 0;
    min-width: 220px;
  }

  /* Ensure checkboxes container stays within bounds */
  > div > div:last-child {
    flex-wrap: wrap;
    white-space: nowrap;
    max-width: 100%;
    overflow: hidden;
  }

  /* Search input — after date-basis + date-range (3rd child) */
  > div > div:nth-child(3) {
    max-width: 100%;
    overflow: hidden;
  }

  > div > div:nth-child(3) > * {
    max-width: 100%;
  }

  @media (max-width: 1200px) {
    > div {
      flex-wrap: wrap !important;
      gap: 12px !important;
    }

    > div > * {
      flex: 1 1 auto;
      min-width: 200px;
      max-width: 100%;
    }

    /* Make checkboxes wrap on smaller screens */
    > div > div:last-child {
      flex: 1 1 100%;
      min-width: 100%;
    }
  }

  @media (max-width: 768px) {
    > div {
      flex-direction: column !important;
      align-items: stretch !important;
      gap: 12px !important;
    }

    > div > * {
      flex: 1 1 100% !important;
      min-width: 100% !important;
      max-width: 100% !important;
    }
  }
`

const StyledSettingsCollapse = styled(Collapse)`
  background: transparent;

  .ant-collapse-item {
    border: 1px solid rgba(0, 0, 0, 0.06);
    border-radius: 10px;
    background: #fafafa;
  }

  .ant-collapse-header {
    font-weight: 600;
    color: #333 !important;
    padding: 12px 16px 12px 36px !important;
  }

  .ant-collapse-arrow {
    left: 14px !important;
  }

  .ant-collapse-content-box {
    padding: 0 16px 16px !important;
  }
`

const SettingsContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`

const ToggleDivider = styled.div`
  height: 1px;
  background-color: rgba(0, 0, 0, 0.06);
  margin: 4px 0;
`

const ToggleSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`

const EmailSettingsCard = styled.section`
  background: #ffffff;
  border: 1px solid rgba(0, 0, 0, 0.06);
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.04);
`

const EmailSettingsHeader = styled.div`
  margin-bottom: 8px;
`

const EmailSettingsTitle = styled.h3`
  margin: 0 0 4px 0;
  font-size: 18px;
  font-weight: 600;
`

const EmailSettingsSubtitle = styled.p`
  margin: 0;
  color: #6b6b6b;
  font-size: 13px;
`

const EmailSettingsHint = styled.p`
  margin: 0 0 14px 0;
  font-size: 13px;
  color: #8c8c8c;
`

const EmailSettingsContent = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 16px;
`

const EmailSettingsRow = styled.div`
  display: flex;
  flex-direction: row;
  gap: 24px;
  align-items: flex-end;
`

const EmailInputSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

const EmailInputLabel = styled.label`
  font-size: 14px;
  font-weight: 600;
  color: #333;
`

const SaveButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 8px;
`

const SavedIndicator = styled.div`
  padding: 8px 16px;
  background: #f6ffed;
  border: 1px solid #b7eb8f;
  border-radius: 6px;
  color: #52c41a;
  font-weight: 500;
  font-size: 14px;
`

const EmailSettingsOverlay = styled.div`
  position: absolute;
  inset: 0;
  cursor: not-allowed;
  background: rgba(255, 255, 255, 0.45);
  border-radius: 8px;
  z-index: 2;
`

const InnerDiv = styled.div`
  background-color: ${({ theme }) => theme.colours.lettuceGreen} !important;
`

const Container = styled.div`
  display: flex;
  align-items: center;
  margin: 0;
  gap: 12px;
`

const Label = styled.p`
  margin: 0;
  font-size: 14px;
  color: #666;
  line-height: 1.5;
`

// antd notifications render outside the app theme — plain values only.
const NotificationButtons = styled.span`
  display: inline-flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 8px;
`

export default Receipting
